const id = {
  common: {
    remove: "Hapus",
    portal: "Portal",
    role: "Peran",
    quantity: "Jumlah",
    amount: "Jumlah",
    date: "Tanggal",
    label: "Label",
    change: "Ubah",
    campaignName: "Nama Kampanye",
    createdBy: "Dibuat Oleh",
    method: "Metode",
    openingDate: "Tanggal Buka",
    closingDate: "Tanggal Tutup",
    production: "Produksi",
    packing: "Pengemasan",
    payments: "Pembayaran",
    totalOrders: "Total Pesanan",
    totalRevenue: "Total Pendapatan",
    activeCampaigns: "Kampanye Aktif",
    totalMembers: "Total Anggota",
    buyerName: "Nama Pembeli",
    totalPrice: "Total Harga",
    orderId: "ID Pesanan",
    customer: "Pelanggan",
    order: "Pesanan",
    appName: 'Cheeco',
    english: 'Bahasa Inggris',
    language: 'Bahasa',
    languageDescription: 'Pilih bahasa tampilan untuk browser ini.',
    languageSaved: 'Preferensi bahasa berhasil diperbarui.',
    save: 'Simpan',
    saving: 'Menyimpan...',
    saveSettings: 'Simpan Pengaturan',
    cancel: 'Batal',
    processing: 'Memproses...',
    reject: 'Tolak',
    confirm: 'Konfirmasi',
    delete: 'Hapus',
    deleting: 'Menghapus...',
    deleteRecord: 'Hapus Data',
    deleteRecordConfirmation: 'Yakin ingin menghapus data ini? Tindakan ini tidak mudah dibatalkan.',
    closeNotification: 'Tutup notifikasi',
    savedSuccessfully: 'Data berhasil disimpan.',
    requiredWarning: 'Silakan lengkapi semua kolom wajib.',
    saveError: 'Tidak dapat menyimpan data. Silakan coba lagi.',
    importSuccess: 'Impor CSV berhasil diselesaikan.',
    backToDashboard: 'Kembali ke Dashboard',
    backToLogin: 'Kembali ke Login',
    continueToLogin: 'Lanjut ke Login',
    loading: 'Memuat...',
    search: 'Cari',
    all: 'Semua',
    status: 'Status',
    actions: 'Aksi',
    name: 'Nama',
    class: 'Kelas',
    age: 'Usia',
    email: 'Email',
    phone: 'Telepon',
    address: 'Alamat',
    product: 'Produk',
    products: 'Produk',
    campaign: 'Kampanye',
    campaigns: 'Kampanye',
    staff: 'Staf',
    vendors: 'Vendor',
    order: 'Pesanan',
    orders: 'Pesanan',
    member: 'Anggota',
    members: 'Anggota',
    settings: 'Pengaturan',
    reports: 'Laporan',
    roles: 'Peran',
    dashboard: 'Dashboard',
    invoice: 'Faktur',
    printPdf: 'Cetak PDF',
    downloadPdf: 'Unduh PDF',
    printInvoice: 'Cetak Faktur',
    downloadInvoice: 'Unduh Faktur',
    paymentStatus: 'Status Pembayaran',
    paymentMethod: 'Metode Pembayaran',
    paid: 'Lunas',
    pending: 'Menunggu',
    failed: 'Gagal',
    approved: 'Disetujui',
    rejected: 'Ditolak',
    draft: 'Draf',
    closed: 'Ditutup',
    open: 'Buka',
    noResults: 'Tidak ada hasil.',
    noSettings: 'Tidak ada pengaturan.',
    unableToLoad: 'Tidak dapat memuat data.',
    unableToSave: 'Tidak dapat menyimpan perubahan.',
    updated: 'Perubahan berhasil diperbarui.',
    sessionExpired: 'Sesi berakhir. Silakan login kembali.',
    accessDenied: 'Akses ditolak.',
    forbiddenPermission: 'Akses ditolak: Anda tidak memiliki izin yang dibutuhkan.',
    selectFileFirst: 'Silakan pilih file terlebih dahulu.',
    chooseLanguage: 'Pilih bahasa',
    myProfile: 'Profil Saya',
    openNavigation: 'Buka navigasi',
    logout: 'Keluar',
    user: 'Pengguna',
    currentUser: 'Pengguna Saat Ini',
    organizationNavigation: 'Navigasi organisasi',
    organizationLabel: 'Organisasi',
    categories: 'Kategori',
    inventory: 'Inventaris',
    paymentCenter: 'Pusat Pembayaran',
    pendingApprovals: 'Persetujuan Menunggu',
    viewAll: 'Lihat Semua',
    storeApprovals: 'Persetujuan Toko',
    campaignReviews: 'Tinjauan Kampanye',
    memberReports: 'Laporan Anggota',
    activityLogs: 'Log Aktivitas',
    printLabels: 'Cetak Label',
    platformProducts: 'Produk Platform',
    registerOrganization: 'Daftar Organisasi',
    registerSchool: 'Daftar Sekolah',
    claimOrganization: 'Klaim Organisasi Anda',
    signIn: 'Masuk',
    organizationPortal: 'Portal Organisasi',
    schoolPortal: 'Portal Sekolah',
    parentPortal: 'Portal Orang Tua',
    vendorPortal: 'Portal Vendor',
    platformPortal: 'Portal Platform',
    yes: 'Ya',
    no: 'Tidak',
    bag: 'Tas',
    profile: 'Profil',
    searchAnything: 'Cari apa saja...',
    superAdmin: 'Super Admin',
    memberStudent: 'Siswa',
    memberGeneric: 'Anggota',
    administrator: 'Administrator',
    principal: 'Kepala Sekolah',
    president: 'Ketua',
    company: 'Perusahaan',
    employee: 'Karyawan',
    manager: 'Manajer',
    business: 'Bisnis',
    owner: 'Pemilik',
    volunteer: 'Relawan',
    coordinator: 'Koordinator',
    statusLabels: {
    submitted: "Dikirim",
    published: "Diterbitkan",
    open: "Terbuka",
      draft: 'Draf',
      rfq_open: 'RFQ Dibuka',
      closed: 'Ditutup',
      pending: 'Menunggu',
      pending_setup: 'Menunggu Pengaturan',
      active: 'Aktif',
      disabled: 'Dinonaktifkan',
      suspended: 'Ditangguhkan',
      awarded: 'Diberikan',
      not_awarded: 'Tidak Diberikan',
      production: 'Produksi',
      packaging: 'Pengemasan',
      packing: 'Pengemasan',
      delivery: 'Pengiriman',
      ready_for_delivery: 'Siap Dikirim',
      delivered: 'Terkirim',
      completed: 'Selesai',
      cancelled: 'Dibatalkan',
      archived: 'Diarsipkan',
      paid: 'Lunas',
      paid_online: 'Lunas Online',
      organization_paid: 'Dibayar Organisasi',
      manual_verified: 'Terverifikasi Manual',
      awaiting_approval: 'Menunggu Persetujuan',
      failed: 'Gagal',
      refunded: 'Dikembalikan',
      super_admin: 'Admin Super',
      platform_admin: 'Admin Platform',
      tenant_admin: 'Admin',
      buyer: 'Pembeli',
      vendor: 'Vendor',
      independent_seller: 'Penjual Independen',
      school: 'Sekolah',
      pending_approval: 'Menunggu Persetujuan',
      requested_info: 'Info Diminta',
      approved: 'Disetujui',
      rejected: 'Ditolak',
    },
    bids: 'Tawaran',
    action: 'Aksi',
    active: 'Aktif',
    close: 'Tutup',
    description: 'Deskripsi',
    edit: 'Edit',
    inactive: 'Nonaktif',
    independentPortal: 'Portal Mandiri',
    next: 'Berikutnya',
    of: 'dari',
    organizationAdminLogin: 'Login Admin Organisasi',
    organizations: 'Organisasi',
    previous: 'Sebelumnya',
    showing: 'Menampilkan',
    size: 'Ukuran',
    stock: 'Stok',
    to: 'hingga',
    unknown: 'tidak diketahui',
    workspace: 'Ruang Kerja',
    back: 'Kembali',
    continue: 'Lanjut',
    parent: 'Orang Tua',
    school: 'Sekolah',
  },
  auth: {
    forgotPassword: 'Lupa Kata Sandi',
    resetPassword: 'Atur Ulang Kata Sandi',
    sendResetLink: 'Kirim Tautan Reset',
    newPassword: 'Kata Sandi Baru',
    confirmPassword: 'Konfirmasi Kata Sandi',
    emailAddress: 'Alamat Email',
    tokenMissing: 'Token reset tidak ditemukan. Silakan minta tautan reset baru.',
    resetSuccess: 'Kata sandi berhasil diperbarui. Silakan login kembali.',
    resetFailed: 'Tidak dapat mengatur ulang kata sandi.',
    resetLinkSent: 'Jika akun dengan email tersebut ada, tautan reset sudah dikirim.',
    resetLinkFailed: 'Tidak dapat mengirim tautan reset. Silakan coba lagi.',
    loginFailed: 'Login gagal. Silakan periksa data Anda.',
    parentPortalRequired: 'Akun orang tua harus login melalui Portal Orang Tua.',
    serverUnavailable: 'Tidak dapat terhubung ke server. Periksa domain atau API lalu coba lagi.',
    emailVerified: 'Email Terverifikasi',
    emailVerifiedDescription: 'Alamat email Anda berhasil diverifikasi.',
    verificationProcessed: 'Permintaan verifikasi Anda telah diproses.',
    verificationContinue: 'Sekarang Anda dapat melanjutkan menggunakan Cheeco dengan alamat email ini.',
    signIn: 'Masuk',
    emailRequired: 'Email wajib diisi',
    enterValidEmail: 'Silakan masukkan alamat email yang valid',
    enterYourEmail: 'Masukkan email Anda',
    emailPlaceholder: 'anda@contoh.com',
    checkYourEmail: 'Periksa Email Anda',
    magicLinkSent: 'Tautan Ajaib Terkirim',
    weSentMagicLinkTo: 'Kami mengirim tautan ajaib ke',
    weSentNewMagicLinkTo: 'Kami mengirim tautan ajaib baru ke',
    checkYourInbox: 'Silakan periksa kotak masuk Anda.',
    linkExpiresIn10: 'Tautan kedaluwarsa dalam 10 menit dan hanya dapat digunakan sekali.',
    requestAnotherLinkIn: 'Anda dapat meminta tautan lain dalam',
    minutes: 'menit',
    sendingMagicLink: 'Mengirim tautan ajaib',
    resendMagicLink: 'Kirim Ulang Tautan Ajaib',
    sending: 'Mengirim...',
    didntReceive: 'Tidak menerimanya? Klik untuk mengirim ulang',
    useDifferentEmail: 'Gunakan email berbeda',
    useDifferentEmailTitle: 'Gunakan Email Berbeda',
    emailAlreadyRegistered: 'Email ini sudah terdaftar',
    noPasswordNeeded: 'Tidak perlu kata sandi. Kami akan mengirimkan tautan ajaib yang aman.',
    passwordlessCommerce: 'Komersial Sekolah Tanpa Kata Sandi',
    passwordlessCommerceTagline: 'Cheeco — Komersial Sekolah Tanpa Kata Sandi',
    welcomeToCheeco: 'Selamat Datang di Cheeco',
    tellUsWhoYouAre: 'Beri tahu kami siapa Anda, lalu masukkan email untuk melanjutkan.',
    iAmRegisteringAs: 'Saya mendaftar sebagai',
    continueWithEmail: 'Lanjutkan dengan email',
    backToHome: 'Kembali ke Beranda',
    requestTooLong: 'Permintaan terlalu lama. Periksa koneksi Anda dan coba lagi.',
    couldNotReach: 'Tidak dapat terhubung ke Cheeco. Periksa koneksi internet Anda dan coba lagi.',
    tooManyAttempts: 'Terlalu banyak percobaan. Tunggu beberapa menit lalu coba lagi.',
    checkEmailEntered: 'Periksa email yang Anda masukkan lalu coba lagi.',
    serverUnavailableShort: 'Server kami untuk sementara tidak tersedia. Silakan coba lagi dalam beberapa menit. Jika masalah berlanjut, hubungi support@cheeco.com.',
    unexpectedError: 'Terjadi kesalahan yang tidak terduga. Silakan coba lagi.',
    enterEmailAddress: 'Silakan masukkan alamat email Anda.',
    enterValidEmailWithExample: 'Silakan masukkan alamat email yang valid (mis. nama@domain.com).',
    tooManyWait: 'Terlalu banyak percobaan. Tunggu sebelum meminta tautan lain.',
    failedToSend: 'Gagal mengirim tautan ajaib. Silakan coba lagi.',
    retryIn: 'Coba lagi dalam',
    wait: 'Tunggu',
    sendMeNewLink: 'Kirimi Saya Tautan Ajaib Baru',
    linkExpired: 'Tautan Kedaluwarsa',
    linkExpiredDescription: 'Tautan ajaib ini telah kedaluwarsa. Demi keamanan, tautan hanya berlaku selama 10 menit. Silakan minta yang baru.',
    linkAlreadyUsed: 'Tautan Sudah Digunakan',
    linkAlreadyUsedDescription: 'Tautan ajaib ini sudah digunakan. Setiap tautan ajaib hanya dapat digunakan sekali demi keamanan. Silakan minta yang baru.',
    invalidLink: 'Tautan Tidak Valid',
    invalidLinkDescription: 'Tautan ini tampak tidak valid atau rusak. Silakan minta tautan ajaib baru.',
    tokenNotFound: 'Token Tidak Ditemukan',
    tokenNotFoundDescription: 'Token tautan ajaib tidak ditemukan. Mungkin sudah digunakan atau dihapus. Silakan minta yang baru.',
    noLinkFound: 'Tautan Tidak Ditemukan',
    noLinkFoundDescription: 'Tidak ada token autentikasi yang ditemukan di URL. Silakan minta tautan ajaib baru.',
    networkError: 'Kesalahan Jaringan',
    networkErrorDescription: 'Tidak dapat terhubung ke server untuk memverifikasi tautan Anda. Ini sering disebabkan oleh service worker lama. Silakan muat ulang paksa (Ctrl+Shift+R) dan coba lagi.',
    requestTimeoutTitle: 'Permintaan Waktu Habis',
    requestTimeoutDescription: 'Permintaan verifikasi waktu habis. Silakan coba lagi.',
    connectionError: 'Kesalahan Koneksi',
    connectionErrorDescription: 'Kami tidak dapat memverifikasi tautan Anda karena Anda tampak offline. Periksa koneksi Anda dan coba lagi.',
    tooManyRequests: 'Terlalu Banyak Permintaan',
    tooManyRequestsDescription: 'Terlalu banyak percobaan verifikasi. Tunggu beberapa menit sebelum mencoba lagi.',
    serverError: 'Kesalahan Server',
    serverErrorDescription: 'Server kami mengalami kesalahan saat memverifikasi tautan Anda. Silakan coba lagi dalam beberapa menit. Jika masalah berlanjut, hubungi dukungan.',
    linkInvalidOrExpired: 'Tautan Tidak Valid atau Kedaluwarsa',
    linkInvalidOrExpiredDescription: 'Tautan ajaib ini tidak valid, kedaluwarsa, atau sudah digunakan. Silakan minta yang baru.',
    needHelpContact: 'Perlu bantuan? Hubungi administrator sekolah Anda atau',
    needHelpFull: 'Perlu bantuan? Hubungi administrator sekolah Anda atau dukungan Cheeco.',
    cheecoSupport: 'dukungan Cheeco',
    noTokenProvided: 'Tidak ada token autentikasi yang diberikan. Silakan minta tautan ajaib baru.',
    malformedLink: 'Tautan ini tampak rusak. Silakan minta tautan ajaib baru.',
    verificationFailed: 'Verifikasi gagal. Silakan coba lagi.',
    multipleRetryFailed: 'Banyak percobaan ulang gagal. Silakan minta tautan ajaib baru.',
    verifyingYourLink: 'Memverifikasi tautan Anda...',
    pleaseWaitVerify: 'Mohon tunggu sementara kami memverifikasi tautan ajaib Anda.',
    thisMayTakeSeconds: 'Ini mungkin membutuhkan beberapa detik',
    loginSuccessful: 'Login Berhasil',
    redirectingToDashboard: 'Mengalihkan Anda ke dashboard...',
    magicLinksExpire: 'Tautan ajaib kedaluwarsa setelah 10 menit demi keamanan. Silakan minta yang baru.',
    linkAlreadyUsed2: 'Tautan ini sudah digunakan. Setiap tautan ajaib hanya dapat digunakan sekali.',
    multipleAttemptsFailed: 'Banyak percobaan gagal. Ini mungkin karena masalah jaringan atau tautan telah kedaluwarsa.',
    tryAgain: 'Coba Lagi',
    requestNewLink: 'Minta Tautan Baru',
    verifyingSecureLink: 'Memverifikasi tautan aman...',
    signingYouIn: 'Sedang login...',
    redirecting: 'Mengalihkan...',
    organisationAccess: 'Akses Organisasi',
    organisationAdminLogin: 'Login Admin Organisasi',
    organisationSuperAdminLogin: 'Login Super Admin Organisasi',
    organisationMemberUser: 'Anggota / Pengguna Organisasi',
  },
  parent: {
    school: 'Sekolah',
    profileUpdated: 'Profil diperbarui.',
    fullName: 'Nama Lengkap',
    yourName: 'Nama Anda',
    yourEmail: 'anda@contoh.com',
    phoneNumber: 'Nomor telepon',
    yourAddress: 'Alamat Anda',
    languageUpdated: 'Bahasa diperbarui.',
    saveChanges: 'Simpan Perubahan',
    manageFamily: 'Kelola Anggota Keluarga',
    noFamilyMembers: 'Belum ada anggota keluarga yang ditambahkan.',
    addFamilyMember: 'Tambah Anggota Keluarga',
    relationship: 'Hubungan',
    memberName: 'Nama Anggota',
    enterName: 'Masukkan nama',
    classPlaceholder: 'mis. 5 Aman',
    adding: 'Menambah...',
    myKids: 'Anak-Anak Saya',
    addStudent: 'Tambah Siswa',
    addStudentDescription: 'Tambah informasi anak Anda.',
    studentName: 'Nama Siswa',
    studentNamePlaceholder: 'mis. Ahmad Hakimi',
    classLabel: 'Kelas',
    classPlaceholderStudent: 'mis. 3 Amanah',
    sportsHouse: 'Rumah Olahraga',
    selectSportsHouse: 'Pilih Rumah Olahraga',
    mySchools: 'Sekolah Saya',
    students: 'Siswa',
    manage: 'Kelola',
    connectSchool: 'Hubungkan Sekolah Lain',
    edit: 'Edit',
    memberAddFailed: 'Tidak dapat menambah anggota.',
    memberAdded: 'Anggota berhasil ditambahkan.',
    familyDashboardFailed: 'Tidak dapat memuat dashboard keluarga.',
    duplicateMerged: 'Anggota duplikat berhasil digabungkan.',
    noOrganizationProducts: 'Organisasi ini belum memiliki produk yang tersedia untuk dipesan.',
    productNotFound: 'Produk organisasi tidak ditemukan untuk dipesan.',
    organization: 'Organisasi',
    organizationGroupsDescription: 'Setiap organisasi menampilkan jumlah anggota, produk aktif, kemajuan, dan pengumuman.',
    addMemberFirst: 'Tambahkan anggota Anda terlebih dahulu. Dashboard akan mengelompokkan pesanan berdasarkan organisasi.',
    noActiveProductsForOrganization: 'Anggota sudah ditambahkan, tetapi organisasi terkait belum memiliki produk aktif.',
    addMemberToSeeOrganization: 'Tambahkan anggota untuk melihat detail organisasi.',
    organizationProductsAvailable: 'Produk organisasi tersedia',
    noActiveProducts: 'Tidak ada produk aktif yang tersedia untuk organisasi ini.',
    noProductsAvailable: 'Belum ada produk yang tersedia. Produk akan muncul setelah Administrator Organisasi Anda menerbitkannya.',
    noOrdersTitle: 'Belum ada pesanan',
    noOrdersForMember: 'Anggota ini belum memiliki pesanan tercatat.',
    noFamilyOrders: 'Akun ini belum membuat pesanan.',
    orderClosed: 'Pesanan Ditutup',
    memberOrders: 'Pesanan Anggota',
    viewDetails: 'Lihat Detail',
    paidComplete: 'Pembayaran selesai',
    receiptFailed: 'Tidak dapat memuat tanda terima.',
    invoicePdfFailed: 'Tidak dapat membuat PDF faktur.',
    receiptTitle: 'Tanda Terima Pesanan',
    redirectingToOrder: 'Mengalihkan ke detail pesanan dalam {{seconds}}d...',
    checkoutAndPay: 'Checkout dan Bayar',
    processing: 'Memproses...',
    orderSummary: 'Ringkasan Pesanan',
    paymentCompleteSummary: 'Pembayaran selesai. Ini ringkasan pesanan Anda.',
    orderDeadlinePassed: 'Pesanan ditutup. Batas waktu produk telah berlalu.',
    orderCreatedMissingId: 'Pesanan dibuat, tetapi ID pesanan tidak ditemukan. Silakan periksa dashboard Anda.',
    organizationPaysSuccess: 'Pesanan berbayar organisasi berhasil dibuat. Status sudah lunas.',
    orderCreatedRedirect: 'Pesanan berhasil dibuat. Mengalihkan ke pembayaran...',
    orderCreatedPay: 'Pesanan berhasil dibuat. Silakan lanjutkan pembayaran.',
    cartAdded: 'Item ditambahkan ke keranjang.',
    cartPaid: 'Keranjang berhasil dikirim dan dibayar.',
    cartProcessed: 'Checkout berhasil. Semua item diproses dengan ID keranjang yang sama.',
    orderClosedShort: 'Pesanan ditutup.',
    deadline: 'Batas waktu: {{value}}',
    noOrderItems: 'Tidak ada item pesanan yang ditemukan untuk referensi ini.',
    backToOrders: 'Kembali ke Daftar Pesanan',
    exactNameClass: 'Masukkan nama lengkap dan kelas yang tepat. Jika tidak ada kecocokan, sistem akan memberi tahu bahwa anggota tidak ditemukan.',
  },
  organization: {
    workspace: 'Ruang Kerja Organisasi',
    workspaces: 'Ruang Kerja',
    workspaceDashboard: 'Dashboard Ruang Kerja',
    workspaceMembers: 'Anggota Ruang Kerja',
    workspaceAdministrators: 'Administrator Ruang Kerja',
    workspaceReports: 'Laporan Ruang Kerja',
    workspaceSettings: 'Pengaturan Ruang Kerja',
    currentWorkspace: 'Ruang Kerja Saat Ini',
    workspaceSurfaces: 'Permukaan Ruang Kerja',
    workspaceName: 'Nama Ruang Kerja',
    slug: 'Slug',
    typeLabel: 'Tipe',
    active: 'Aktif',
    workspaceLoadFailed: 'Tidak dapat memuat informasi ruang kerja.',
    settingsTitle: 'Pengaturan Organisasi',
    settingsDescription: 'Jaga profil organisasi dan detail kontak Anda tetap terbarui.',
    profile: 'Profil Organisasi',
    profileDescription: 'Identitas publik dan informasi kontak utama',
    type: 'Jenis Organisasi',
    contactPerson: 'Kontak Person',
    mobileNumber: 'Nomor Ponsel',
    updated: 'Pengaturan organisasi diperbarui.',
    membersLoadFailed: 'Tidak dapat memuat daftar anggota.',
    dashboardLoadFailed: 'Tidak dapat memuat ringkasan pesanan organisasi.',
    logoUpdated: 'Logo organisasi berhasil diperbarui.',
    logoUploadFailed: 'Tidak dapat mengunggah logo organisasi.',
    draftSaved: 'Draf berhasil disimpan. Anda dapat mengeditnya kapan saja.',
    draftSaveFailed: 'Tidak dapat menyimpan draf produk.',
    productInfoMissing: 'Silakan lengkapi informasi produk: {{fields}}.',
    productSubmitted: 'Produk dikirim untuk persetujuan admin platform.',
    productSubmitFailed: 'Tidak dapat mengirim produk untuk persetujuan.',
    submissionCancelled: 'Pengiriman dibatalkan. Produk kembali ke status draf.',
    cancelSubmissionFailed: 'Tidak dapat membatalkan pengiriman produk.',
    uploadStudentsDenied: 'Akses ditolak: Anda tidak memiliki izin untuk mengunggah anggota.',
    remindersDenied: 'Akses ditolak: Anda tidak memiliki izin untuk mengirim pengingat.',
    remindersSent: 'Pengingat dikirim untuk {{count}} anggota.',
    remindersFailed: 'Tidak dapat mengirim pengingat.',
    selectProductFirst: 'Silakan pilih produk terlebih dahulu.',
    selectSpecificMembers: 'Silakan pilih setidaknya satu anggota untuk mode Khusus.',
    bulkOrderSuccess: 'Pesanan massal selesai. Dibuat: {{created}}, Dilewati: {{skipped}}.',
    bulkOrderFailed: 'Pesanan massal gagal.',
    uploadSuccess: 'Unggah Berhasil',
    productApprovedBuyerVisible: 'Produk telah disetujui dan kini terlihat oleh pembeli.',
    draftNotSubmitted: 'Draf belum dikirim ke admin platform.',
    rejectionReason: 'Alasan penolakan: {{reason}}',
    noReason: 'Tidak ada alasan yang diberikan.',
  },
  schoolAdminDashboard: {
    activeCampaigns: 'Kampanye Aktif',
    totalMembers: 'Total Anggota',
    verifiedMembers: 'Anggota Terverifikasi',
    pendingMembers: 'Anggota Tertunda',
    ordersReceived: 'Pesanan Diterima',
    campaignCompletion: 'Penyelesaian Kampanye',
    productionProgress: 'Kemajuan Produksi',
    packingProgress: 'Kemajuan Pengemasan',
    deliveryProgress: 'Kemajuan Pengiriman',
    noActiveCampaigns: 'Tidak ada kampanye aktif',
    createCampaign: 'Buat Kampanye',
    uploadRoster: 'Unggah Roster',
    viewDetails: 'Lihat Detail',
    closeCampaign: 'Tutup Kampanye',
    completionPercentage: '% Penyelesaian',
    members: 'Anggota',
    orders: 'Pesanan',
    status: 'Status',
  },
  independent: {
    myStore: 'Toko Saya',
    notifications: 'Notifikasi',
    seller: 'Penjual',
  },
  nav: {
    members: "Anggota",
    verification: "Verifikasi",
    campaigns: 'Kampanye',
    orders: 'Pesanan',
    home: 'Beranda',
    shop: 'Belanja',
    cart: 'Keranjang',
    profile: 'Profil',
    dashboard: 'Dashboard',
    rfqs: 'RFQ Terbuka',
    quotations: 'Penawaran',
    operations: 'Operasional',
    reports: 'Laporan',
    activityLogs: 'Log Aktivitas',
    products: 'Produk',
    customers: 'Pelanggan',
    analytics: 'Analitik',
    store: 'Toko Saya',
    settings: 'Pengaturan',
    help: 'Bantuan',
    schools: 'Sekolah',
    organizations: 'Organisasi',
    vendors: 'Vendor',
    categories: 'Kategori',
    inventory: 'Inventaris',
    campaignReviews: 'Tinjauan Kampanye',
    bids: 'Penawaran',
    vouchers: 'Voucher',
    memberReports: 'Laporan Anggota',
    directory: 'Direktori',
    myKids: 'Anak-Anak Saya',
    manageSchools: 'Kelola Sekolah',
    manageOrganizations: 'Kelola Organisasi',
    pendingVendors: 'Vendor Tertunda',
    finance: 'Keuangan',
  },
  superadmin: {
    viewAll: 'Lihat Semua',
    viewAllLowercase: 'Lihat semua',
    approve: 'Setujui',
    reject: 'Tolak',
    cancel: 'Batal',
    confirm: 'Konfirmasi',
    save: 'Simpan',
    superAdmin: 'Super Admin',
    loginDescription: 'Masuk ke portal tata kelola platform.',
    backToHome: 'Kembali ke Beranda',
    operationsCenter: 'Pusat Operasi',
    governanceDashboard: 'Dashboard Tata Kelola',
    governanceSubtitle: 'Kesehatan platform, eskalasi, dan pengawasan lintas penyewa',
    attentionRequired: 'Perlu Perhatian',
    noAttentionRequired: 'Tidak ada yang memerlukan perhatian saat ini.',
    platformHealth: 'Kesehatan Platform',
    everythingLooksNormal: 'Semuanya terlihat normal',
    viewDetailedReports: 'Lihat Laporan Detail',
    recentActivity: 'Aktivitas Terkini',
    viewFullActivityLog: 'Lihat Log Aktivitas Lengkap',
    registered: 'terdaftar',
    order: 'Pesanan',
    from: 'dari',
    reviewAll: 'Tinjau Semua',
    totalSchools: 'Total Sekolah',
    totalOrders: 'Total Pesanan',
    totalRevenue: 'Total Pendapatan',
    totalUsers: 'Total Pengguna',
    pendingOrganizations: 'Organisasi menunggu pengaturan',
    loadingDashboard: 'Memuat dashboard...',
    unableToLoadDashboard: 'Tidak dapat memuat dashboard.',
    activate: 'Aktifkan',
    addPlatformAdmin: 'Tambah Admin Platform',
    addStaff: 'Tambah Staf',
    adminContact: 'Admin / Kontak',
    adminEmailPlaceholder: 'Email admin',
    create: 'Buat',
    createStaff: 'Buat Staf',
    custom: 'Kustom',
    deactivate: 'Nonaktifkan',
    department: 'Departemen',
    disabled: 'Nonaktif',
    editStaff: 'Edit Staf',
    invitationReset: 'Undangan berhasil diatur ulang.',
    jobTitle: 'Jabatan',
    loadingActivity: 'Memuat aktivitas...',
    loadingStaff: 'Memuat staf...',
    manageOrganizationsDescription: 'Kelola status organisasi, undangan, dan akun admin.',
    manageUsers: 'Kelola Pengguna',
    manageUsersSubtitle: 'Buat admin platform dan kontrol akses akun.',
    newPassword: 'Kata sandi baru',
    noActivity: 'Tidak ada aktivitas',
    noActivityDescription: 'Tidak ada log aktivitas untuk staf ini.',
    noStaffDescription: 'Belum ada anggota staf. Buat satu untuk memulai.',
    noStaffFound: 'Tidak ada staf ditemukan',
    noUsersDescription: 'Belum ada pengguna platform.',
    noUsersFound: 'Tidak ada pengguna ditemukan',
    permissions: 'Izin',
    resetPassword: 'Atur Ulang Kata Sandi',
    setNewPassword: 'Tetapkan kata sandi baru untuk',
    staffActivity: 'Aktivitas Staf',
    staffCreated: 'Staf berhasil dibuat.',
    staffDisabled: 'Staf dinonaktifkan.',
    staffEnabled: 'Staf diaktifkan.',
    staffManagement: 'Manajemen Staf',
    staffManagementDescription: 'Buat, kelola, dan pantau staf platform internal.',
    staffUpdated: 'Staf berhasil diperbarui.',
    superAdminAccount: 'Akun Super Admin',
    thisUser: 'pengguna ini',
    unableToLoadActivity: 'Tidak dapat memuat log aktivitas.',
    unableToLoadStaff: 'Tidak dapat memuat staf saat ini.',
    unableToResetInvitation: 'Tidak dapat mengatur ulang undangan.',
    unableToSaveStaff: 'Tidak dapat menyimpan staf. Silakan coba lagi.',
    unableToUpdateStatus: 'Tidak dapat memperbarui status.',
    usersCount: '{{count}} pengguna',
    yourPassword: 'Kata sandi Anda',
    rejecting: 'Menolak...',
    approving: 'Menyetujui...',
    processing: 'Memproses...',
    quickActions: 'Aksi Cepat',
    recentOrders: 'Pesanan Terbaru',
    latestSchools: 'Sekolah Terbaru',
    rejectOrder: 'Tolak Pesanan',
    approveOrder: 'Setujui Pesanan',
    rejectThisOrder: 'Tolak pesanan ini?',
    approveThisOrder: 'Setujui pesanan ini?',
    approveThisOrderDescription: 'Silakan konfirmasi jika Anda ingin menyetujui pesanan ini.',
    invitation: 'Undangan',
    editEmail: 'Edit Email',
    editAdminEmail: 'Edit Email Admin',
    resendInvitation: 'Kirim Ulang Undangan',
    enable: 'Aktifkan',
    disable: 'Nonaktifkan',
    suspend: 'Tangguhkan',
    unsuspend: 'Batalkan Penangguhan',
    approvalQueue: 'Antrian Persetujuan',
    productApprovalDetails: 'Detail Persetujuan Produk',
    reviewTrail: 'Jejak Tinjauan',
    manageProducts: 'Kelola Produk',
    addProduct: 'Tambah Produk',
    selectSchool: 'Pilih Sekolah',
    noProducts: 'Tidak ada produk',
    students: 'Siswa',
    orderedStudents: 'Siswa yang Memesan',
    notOrdered: 'Belum Memesan',
    parentEmail: 'Email Orang Tua',
    parentPhone: 'Telepon Orang Tua',
    noStudentsFound: 'Tidak ada siswa ditemukan',
    qty: 'Jml',
    payment: 'Pembayaran',
    manageSchools: 'Kelola Sekolah',
    allZones: 'Semua Zona',
    schoolLevelPrimary: 'Rendah',
    schoolLevelSecondary: 'Menengah',
    slug: 'Slug',
    schoolCode: 'Kode Sekolah',
    zone: 'Zona',
    area: 'Area',
    phoneNumber: 'Nomor Telepon',
    bulkImport: 'Impor Massal Sekolah KL',
    importSchools: 'Impor Sekolah',
    importReadyData: 'Impor 40 Sekolah Siap',
    importReadyDescription: 'Impor otomatis tanpa mengunggah file.',
    filterSchool: 'Filter Sekolah',
    editSchool: 'Edit Sekolah',
    addNewSchool: 'Tambah Sekolah Baru',
    schoolList: 'Daftar Sekolah',
    schoolsCount: '{{count}} sekolah',
    active: 'Aktif',
    inactive: 'Nonaktif',
    reset: 'Atur Ulang',
    updateSchool: 'Perbarui Sekolah',
    saveSchool: 'Simpan Sekolah',
    deleteSchool: 'Hapus Sekolah',
    deleteSchoolConfirmation: 'Hapus sekolah ini? Tindakan ini tidak dapat dibatalkan.',
    noPendingApprovals: 'Tidak ada persetujuan tertunda',
    noPendingApprovalsDescription: 'Tidak ada produk yang menunggu tinjauan saat ini.',
    viewInventory: 'Lihat Inventori',
    schoolsRegistered: 'Sekolah terdaftar',
    ordersRecorded: 'Pesanan tercatat',
    platformUsers: 'Pengguna platform',
    paidRevenue: 'Pendapatan terbayar',
    awaitingReview: 'Menunggu tinjauan',
    pendingApprovalsTitle: 'Persetujuan Tertunda',
    todaysActivity: 'Aktivitas Hari Ini',
    addOrganization: 'Tambah Organisasi',
    pendingVendors: 'Vendor Tertunda',
    bidsManagement: 'Manajemen Tawaran',
    printLabels: 'Cetak Label',
    pendingApprovalsCount: 'Persetujuan Tertunda',
    goodEvening: 'Selamat malam, Super Admin',
    dashboardSubtitle: 'Kelola platform Cheeco',
    dashboardDescription: 'Pantau sekolah, pesanan, vendor, dan aktivitas platform secara real time.',
    reason: 'Alasan',
    noAdmin: 'Tidak ada admin',
    pendingActivation: 'Menunggu Aktivasi',
    invitationSent: 'Undangan Terkirim',
    expired: 'Kedaluwarsa',
    unknown: 'Tidak Diketahui',
    noOrganizationsFound: 'Tidak ada organisasi ditemukan',
    noOrganizationsDescription: 'Tidak ada organisasi dengan status ini.',
    organizationStatusUpdated: 'Status organisasi diperbarui.',
    invitationRegenerated: 'Undangan dibuat ulang dan dikirim.',
    resetAdminPassword: 'Atur ulang kata sandi admin? Undangan baru akan dikirim.',
    passwordReset: 'Kata sandi diatur ulang. Undangan baru terkirim.',
    adminEmailUpdated: 'Email admin diperbarui.',
    schoolDeleted: 'Sekolah berhasil dihapus.',
    importCompleted: 'Impor selesai: {{count}} sekolah berhasil diimpor.',
    readyDataImported: 'Data siap diimpor: {{count}} sekolah diproses.',
    importFileRequired: 'Silakan pilih file impor (.xlsx atau .csv).',
    adminPasswordMin: 'Kata sandi admin default minimal 8 karakter.',
    selectImportFile: 'Pilih sekolah dari daftar siap (opsional)',
    category: 'Kategori',
    domainOptional: 'Domain (opsional)',
    resetAdminPasswordPlaceholder: 'Atur Ulang Kata Sandi Admin (opsional)',
    adminPasswordPlaceholder: 'Kata Sandi Admin',
    loadingApprovals: 'Memuat persetujuan...',
    unableToLoadSchools: 'Tidak dapat memuat sekolah.',
    unableToLoadOrganizations: 'Tidak dapat memuat organisasi.',
    unableToLoadPendingApprovals: 'Tidak dapat memuat persetujuan tertunda.',
    sent: 'Terkirim',
    disableOrganization: 'Organisasi ini akan kehilangan akses ke dashboard.',
    suspendOrganization: 'Organisasi ini akan ditangguhkan segera.',
    rejectOrganization: 'Organisasi ini akan ditolak dan dinonaktifkan.',
    approveOrganization: 'Organisasi ini akan diaktifkan dan email undangan akan dikirim ke admin.',
    noPendingOrders: 'Tidak ada pesanan menunggu persetujuan.',
    orderList: 'Daftar Pesanan',
    ordersCount: '{{count}} pesanan',
    noOrdersFound: 'Tidak ada pesanan ditemukan',
    noOrdersDescription: 'Belum ada pesanan tercatat.',
    details: 'Detail',
    harga: 'Harga',
    hargaJualan: 'Harga Jual',
    kosAsas: 'Biaya Dasar',
    deadline: 'Batas Waktu',
    submitted: 'Dikirim',
    front: 'Depan',
    back: 'Belakang',
    logo: 'Logo',
    noImage: 'Tidak ada gambar',
    schoolInformation: 'Informasi Sekolah',
    school: 'Sekolah',
    contact: 'Kontak',
    email: 'Email',
    phone: 'Telepon',
    status: 'Status',
    reviewedAt: 'Ditinjau Pada',
    reviewedBy: 'Ditinjau Oleh',
    reviewerEmail: 'Email Peninjau',
    noAdditionalDescription: 'Tidak ada deskripsi tambahan.',
    variations: 'Variasi',
    stock: 'Stok',
    rejectionReason: 'Alasan Penolakan',
    loadingProductApprovalDetails: 'Memuat detail persetujuan produk...',
    productNotFound: 'Produk tidak ditemukan.',
    allSchoolProductsWaiting: 'Semua produk sekolah menunggu tinjauan',
    pendingCount: 'Jumlah Tertunda',
    noPendingProductsReview: 'Tidak ada produk menunggu untuk ditinjau saat ini.',
    orderApprovalQueue: 'Antrian Persetujuan Pesanan',
    pendingApproval: 'Menunggu Persetujuan',
    defaultAdminPassword: 'Kata sandi admin default',
    searchNameSlugArea: 'Cari nama/slug/area',
    operationsCenterSubtitle: 'Apa yang memerlukan perhatian Anda hari ini',
    pendingProductsApproval: 'Produk menunggu persetujuan',
    pendingStoreUpdates: 'Pembaruan toko menunggu tinjauan',
    productsActive: 'Produk Aktif',
    failedPayments: 'Pembayaran Gagal',
    expiredInvitations: 'Undangan Kedaluwarsa',
    operationsQueue: 'Antrian Operasi',
    noOperationsQueue: 'Tidak ada dalam antrian saat ini.',
    viewOperationsCenter: 'Lihat Pusat Operasi',
  },
  platform: {
    systemSettings: 'Pengaturan Sistem',
    createCategory: 'Buat Kategori',
    updateCategory: 'Perbarui Kategori',
    settingsDescription: 'Kelola nilai konfigurasi tingkat platform dan visibilitas pengaturan publik.',
    configurationRegistry: 'Registri Konfigurasi',
    backDashboard: 'Kembali ke Dashboard',
    settingsUpdated: 'Pengaturan sistem berhasil diperbarui.',
    settingsLoadFailed: 'Tidak dapat memuat pengaturan sistem.',
    settingsSaveFailed: 'Tidak dapat menyimpan pengaturan.',
    schoolsLoadFailed: 'Tidak dapat memuat organisasi.',
    vendorLoadFailed: 'Tidak dapat memuat vendor.',
    productsLoadFailed: 'Tidak dapat memuat produk.',
    profitLoadFailed: 'Tidak dapat memuat data keuntungan.',
    deleteSchoolFailed: 'Tidak dapat menghapus organisasi.',
    adminPasswordMin: 'Kata sandi admin minimal 8 karakter untuk login organisasi baru.',
    schoolSavedFailed: 'Tidak dapat menyimpan organisasi.',
    noSchools: 'Belum ada organisasi yang tercatat.',
    manageSchools: 'Kelola organisasi: tambah, ubah, aktifkan, atau nonaktifkan tanpa menghapus.',
    resetPasswordHint: 'Isi kata sandi baru hanya jika ingin reset login organisasi. Kosongkan jika tidak ada perubahan.',
    addCategory: 'Tambah Kategori',
    allStock: 'Semua Stok',
    categoriesDescription: 'Tinjau taksonomi produk yang digunakan di seluruh katalog platform.',
    categorizedProducts: 'Produk Berkategori',
    categorizedProductsInline: 'produk berkategori',
    categoryDeleteFailed: 'Tidak dapat menghapus kategori.',
    categoryDeleted: 'Kategori berhasil dihapus.',
    categoryKey: 'Kunci kategori',
    categoryKeyPlaceholder: 'Kunci (contoh: pakaian)',
    displayName: 'Nama tampilan',
    editCategory: 'Edit Kategori',
    inStock: 'Dalam Stok',
    inventoryDescription: 'Kelola tingkat stok untuk variasi produk di seluruh platform menggunakan katalog produk yang ada.',
    inventorySearchPlaceholder: 'Cari berdasarkan produk, sekolah, slug, atau ukuran',
    lowStock: 'Stok Menipis',
    noCategoriesDescription: 'Buat atau perbarui produk dengan kategori untuk mengisi modul ini.',
    noCategoriesYet: 'Belum ada kategori',
    noInventoryFound: 'Tidak ada catatan inventori',
    noInventoryFoundDescription: 'Coba pencarian atau filter stok lain.',
    outOfStock: 'Stok Habis',
    paymentCenterDescription: 'Kelola konfigurasi pembayaran platform dan visibilitas pengaturan.',
    saveStock: 'Simpan Stok',
    searchCategories: 'Cari kategori',
    sortOrder: 'Urutan',
    stockStatusFilter: 'Filter status stok',
    stockValueInput: 'Input nilai stok',
    totalVariations: 'Total Variasi',
    uncategorizedProducts: 'Produk Tanpa Kategori',
    variationsLabel: 'variasi',
  },
  orders: {
    title: 'Pesanan',
    listTitle: 'Daftar Pesanan dan Formulir Pesanan Manual',
    description: 'Admin organisasi dapat membuat pesanan manual saat pembeli membutuhkan bantuan menggunakan sistem.',
    myOrders: 'Pesanan Saya',
    buyer: 'Pembeli',
    size: 'Ukuran',
    quantity: 'Jumlah',
    amount: 'Total',
    type: 'Jenis',
    completed: 'Selesai',
    pay: 'Bayar',
    manualOrder: 'Pesanan Manual',
    addManualOrder: 'Tambah Pesanan Manual',
    selectProduct: 'Pilih Produk Organisasi',
    noActiveProducts: 'Tidak ada produk aktif yang tersedia untuk organisasi ini.',
    paymentPending: 'Belum Dibayar (Menunggu)',
    paymentPaidCash: 'Dibayar (Tunai)',
    paymentDeposit: 'Pembayaran Sebagian (Deposit)',
    submitOrder: 'Kirim Pesanan',
    submitting: 'Mengirim...',
    pdfLabelsFailed: 'Tidak dapat membuat label PDF.',
    labelsReady: '{{count}} label siap dicetak.',
    onlineBuyer: 'Pembeli Online',
    adminManual: 'Manual Admin',
    noOrders: 'Tidak ada pesanan ditemukan.',
    noMatchingOrders: 'Tidak ada pesanan yang cocok ditemukan.',
    searchPlaceholder: 'Cari pesanan, pembeli, kelas, ukuran, total',
  },
  onboarding: {
    minCharacters: 'Silakan masukkan minimal 2 karakter',
    noSchoolsFoundTerm: 'Tidak ada sekolah ditemukan. Coba kata kunci pencarian lain.',
    searchFailed: 'Pencarian gagal. Silakan coba lagi.',
    enterName: 'Silakan masukkan nama Anda',
    nameMinCharacters: 'Nama minimal 2 karakter',
    enterSchoolName: 'Silakan masukkan nama sekolah',
    selectSchool: 'Silakan pilih sekolah',
    setupFailed: 'Gagal menyelesaikan pengaturan. Silakan coba lagi.',
    schoolStaff: 'Staf Sekolah',
    createOrJoin: 'Buat sekolah baru atau bergabung dengan sekolah yang ada',
    joinYourChild: 'Bergabung dengan sekolah anak Anda menggunakan tautan undangan atau Kode QR',
    yourName: 'Nama Anda',
    joinAs: 'Bergabung Sebagai',
    setup: 'Pengaturan',
    step: 'Langkah pendaftaran',
    progress: 'Kemajuan pendaftaran',
    welcome: 'Selamat Datang di Cheeco!',
    whatIsYourName: 'Siapa nama Anda?',
    yourFullName: 'Nama lengkap Anda',
    iAmJoiningAs: 'Saya bergabung sebagai...',
    selectHowJoining: 'Pilih cara Anda bergabung',
    howWouldYouLike: 'Bagaimana Anda ingin melanjutkan?',
    createNewSchool: 'Buat Sekolah Baru',
    setupSchoolProfile: 'Siapkan profil sekolah Anda dan mulailah mengelola kampanye',
    joinExistingSchool: 'Bergabung dengan Sekolah yang Ada',
    searchForSchool: 'Cari sekolah Anda dan minta untuk bergabung',
    schoolNameExample: 'mis., SMK Bukit Jalil',
    youWillBecomeAdmin: 'Anda akan menjadi Administrator Sekolah dan dapat mengelola kampanye, anggota, dan pengaturan.',
    settingUp: 'Menyiapkan...',
    createSchoolAndContinue: 'Buat Sekolah & Lanjutkan',
    findYourSchool: 'Temukan Sekolah Anda',
    searchBySchoolName: 'Cari berdasarkan nama sekolah atau kode sekolah. Permintaan Anda akan dikirim ke Pemilik Sekolah untuk disetujui.',
    searchByNameOrCode: 'Cari berdasarkan nama atau kode sekolah',
    searching: 'Mencari...',
    selected: 'Dipilih:',
    statusAfterSetup: 'Status setelah pengaturan:',
    requestToJoinSchool: 'Minta Bergabung dengan Sekolah',
    parentAccess: 'Akses Orang Tua',
    parentsOfficialInvitations: 'Orang tua bergabung dengan sekolah hanya melalui undangan resmi.',
    howToJoin: 'Cara bergabung:',
    openInvitationLink: 'Buka tautan undangan dari sekolah Anda',
    scanQRCode: 'Pindai Kode QR yang disediakan sekolah',
    enterInvitationCode: 'Masukkan kode undangan',
    contactAdmin: 'Hubungi administrator sekolah Anda jika membutuhkan undangan.',
    continueAsParent: 'Lanjutkan sebagai Orang Tua',
  },
  schoolSetup: {
    imageTypesAllowed: 'Hanya gambar PNG, JPG, atau WebP yang diizinkan.',
    logoSizeLimit: 'Logo harus lebih kecil dari 2 MB.',
    schoolNameRequired: 'Nama Sekolah wajib diisi.',
    schoolAddressRequired: 'Alamat Sekolah wajib diisi.',
    stateRequired: 'Provinsi wajib diisi.',
    contactNumberRequired: 'Nomor Kontak wajib diisi.',
    profileSavedRefreshing: 'Profil sekolah berhasil disimpan. Memuat ulang...',
    profileSaved: 'Profil sekolah disimpan.',
    unableToSaveProfile: 'Tidak dapat menyimpan profil sekolah.',
    unableToCompleteSetup: 'Tidak dapat menyelesaikan pengaturan.',
    completeProfile: 'Lengkapi Profil Sekolah',
    required: 'Wajib',
    createFirstCampaign: 'Buat Kampanye Pertama Anda',
    inviteSchoolMembers: 'Undang Anggota Sekolah',
    optional: 'Opsional',
    title: 'Pengaturan Sekolah',
    completeProfileDescription: 'Lengkapi profil sekolah Anda untuk membuka akses penuh platform. Ini hanya membutuhkan waktu kurang dari 2 menit.',
    completeProfileDescriptionShort: 'Lengkapi profil sekolah Anda untuk membuka dashboard sekolah Anda.',
    completed: 'Selesai',
    profile: 'Profil Sekolah',
    identityDescription: 'Ini menjadi identitas Anda di semua kampanye dan laporan.',
    logo: 'Logo Sekolah',
    changeLogo: 'Ganti logo',
    uploadLogo: 'Unggah logo sekolah',
    logoFormatHint: 'PNG, JPG atau WebP. Maks 2 MB.',
    schoolName: 'Nama Sekolah',
    schoolNamePlaceholder: 'mis. SMK Putra Impian',
    schoolAddress: 'Alamat Sekolah',
    addressPlaceholder: 'Alamat lengkap termasuk kode pos',
    state: 'Provinsi',
    statePlaceholder: 'mis. Selangor',
    contactNumber: 'Nomor Kontak',
    contactNumberPlaceholder: 'mis. +60 12-345 6789',
    saveAndContinue: 'Simpan & Lanjutkan',
    profileComplete: 'Profil sekolah lengkap!',
    identityActive: 'Identitas sekolah Anda kini aktif di seluruh platform.',
    startOrderDescription: 'Mulai pesanan kaos atau seragam untuk sekolah Anda.',
    optionalStaffDescription: 'Opsional — tambah guru dan wakil kelas.',
  },
  pendingAccess: {
    title: 'Akses Sekolah Tertunda',
    yourRequestToJoin: 'Permintaan Anda untuk bergabung',
    waitingApproval: 'sedang menunggu persetujuan dari Pemilik Sekolah.',
    notificationInfo: 'Anda akan menerima notifikasi setelah Pemilik Sekolah menyetujui permintaan Anda. Ini biasanya membutuhkan waktu 1-2 hari kerja.',
    schoolCode: 'Kode Sekolah:',
    logOut: 'Keluar',
  },
  joinSchool: {
    searchPlaceholder: 'Cari berdasarkan nama, kode sekolah, atau lokasi',
    searchPlaceholderExample: 'mis., SMK Bukit Jalil atau CHC-12345',
    noSchoolsFound: 'Tidak ada sekolah ditemukan. Coba pencarian lain.',
    join: 'Gabung',
    backToSignIn: 'Kembali ke Login',
  },
  notifications: {
    unreadCount: 'Notifikasi: {{count}} belum dibaca',
    markRead: "Tandai dibaca",
    archive: "Arsip",
    saving: "Menyimpan...",
    timelineEvent: "Peristiwa garis waktu",
    title: 'Notifikasi',
    menu: 'Menu notifikasi',
    markAllRead: 'Tandai semua telah dibaca',
    empty: 'Belum ada notifikasi',
    clickToView: 'Klik untuk melihat →',
    unread: 'Belum dibaca',
  },
  dashboard: {
    finishSchoolSetup: 'Selesaikan pengaturan sekolah Anda',
    quickSetupSteps: 'Selesaikan langkah pengaturan cepat untuk membuka dashboard sekolah Anda.',
    goToSetup: 'Ke Pengaturan',
    loadingData: 'Memuat data dashboard...',
  },
  email: {
    resetTitle: 'Atur Ulang Kata Sandi',
    resetIntro: 'Kami menerima permintaan untuk mengatur ulang kata sandi akun Cheeco Anda.',
    resetTenantIntro: 'Kami menerima permintaan untuk mengatur ulang kata sandi untuk {{tenant}}.',
    resetInstruction: 'Klik tombol di bawah untuk mengatur kata sandi baru. Tautan ini berlaku selama {{minutes}} menit.',
    resetButton: 'Atur Ulang Kata Sandi',
    fallbackLink: 'Jika tombol tidak berfungsi, gunakan tautan ini:',
    ignoreReset: 'Jika Anda tidak meminta ini, Anda dapat mengabaikan email ini.',
  },
  membership: {
    title: 'Verifikasi Sekolah',
    statusMember: 'Terverifikasi',
    statusPending: 'Menunggu Verifikasi',
    statusException: 'Dalam Tinjauan',
    verifiedMessage: 'Anda sekarang dapat mengikuti kampanye dan melakukan pemesanan.',
    pendingMessage: 'Verifikasi tidak dapat diselesaikan. Permintaan Anda telah dikirim untuk ditinjau.',
    submitClaim: 'Kirim Verifikasi',
    childName: 'Nama Anak',
    childClass: 'Kelas Anak',
    childHouse: 'Rumah Olahraga Anak',
    pendingQueue: 'Verifikasi Tertunda',
    confirmMember: 'Konfirmasi Keanggotaan',
    markException: 'Tandai sebagai Pengecualian',
    escalatedCases: 'Kasus Eskalasi',
    settings: 'Pengaturan Verifikasi',
    autoEscalationHours: 'Eskalasi Otomatis (Jam)',
    sportsHouseRequired: 'Rumah Olahraga Wajib',
    allowManualOverride: 'Izinkan Pengesahan Manual',
    membershipRequired: 'Keanggotaan Diperlukan',
    campaignGate: 'Gerbang Kampanye Diaktifkan',
    lockedCampaign: 'Selesaikan verifikasi sekolah untuk mengikuti kampanye ini.',
    myMemberships: 'Keanggotaan Saya',
  },
  parentOrder: {
    portalTitle: 'Portal Orang Tua',
    dashboard: 'Dasbor',
    productImage: 'Gambar Produk',
    previewImage: 'Pratinjau gambar produk',
    closePreview: 'Tutup pratinjau gambar',
    priceDeadline: 'Harga + Tenggat',
    productDetails: 'Detail Produk',
    sleeveTypeLabel: 'Tipe Lengan: Lengan Pendek, Lengan Panjang',
    campaignPayment: 'Kampanye / Pembayaran',
    selectCampaign: 'Pilih Kampanye',
    defaultNoCampaign: 'Default (tanpa kampanye)',
    sportsHouse: 'Rumah Olahraga / Tim',
    sleeve: 'Lengan',
    size: 'Ukuran',
    quantity: 'Jumlah',
    total: 'Total',
    shortSleeve: 'Lengan Pendek',
    longSleeve: 'Lengan Panjang',
    noItemsFound: 'Tidak ada item pesanan ditemukan untuk referensi ini.',
    orderNumber: 'Nomor Pesanan',
    selectSportsHouse: 'Pilih Rumah Olahraga',
    orEnterManually: 'atau masukkan secara manual',
    paymentMethod: 'Metode Pembayaran',
    voucherCode: 'Kode Voucher',
    enterVoucherCode: 'Masukkan kode voucher',
    addToCart: 'Tambah ke Keranjang',
    orderClosed: 'Pesanan Ditutup',
    sizeChart: 'Bagan Ukuran',
    sizeChartNotSet: 'Bagan ukuran belum diatur.',
    sizeChartPlaceholder: 'Pengukuran / catatan bagan ukuran',
    measurement: 'Pengukuran',
    unitPrice: 'Harga Satuan',
    itemTotal: 'Total Item',
    orderSuccess: 'Pesanan berhasil dibuat. Silakan lanjutkan pembayaran.',
    orderRecorded: 'Pesanan tercatat. Menunggu pembayaran atau persetujuan.',
    totalAmount: 'Total: {{amount}}',
    back: 'Kembali',
    editOrders: 'Sunting Pesanan',
    orderLabel: 'Pesanan',
    orderIdLabel: 'Pesanan #{{number}}',
    fullNameClassHint: 'Masukkan nama lengkap dan kelas yang tepat. Jika tidak ada kecocokan, sistem akan memberi tahu bahwa murid tidak ditemukan.',
    save: 'Simpan',
    receiptTitle: 'Resi — Pesanan',
    orderList: 'Daftar Pesanan',
    viewOrderDetails: 'Lihat Detail Pesanan',
    paymentSource: 'Sumber Pembayaran',
    parentPayment: 'Pembayaran Orang Tua',
    redirectingToOrder: 'Mengalihkan ke detail pesanan dalam {{count}}s...',
    paymentCompleted: 'Pembayaran selesai. Pesanan telah tercatat.',
    memberName: 'Nama {{member}}',
    orderForm: 'Formulir Pesanan',
    cart: 'Keranjang',
    viewCurrentOrder: 'Lihat Pesanan Saat Ini',
    viewCart: 'Lihat Keranjang',
    saving: 'Menyimpan...',
    saveChanges: 'Simpan Perubahan',
    saveAndCheckout: 'Simpan & Checkout',
    memberItem: 'Item {{member}} #{{index}}',
    orderId: 'ID Pesanan',
    backToOrderList: 'Kembali ke Daftar Pesanan',
    ended: 'Selesai',
    endedClosed: 'Selesai! / Ditutup',
    reviewBeforeOrder: "Tinjau detail murid dan ukuran sebelum membuat pesanan.",
    fullNameClassHintDynamic: 'Masukkan nama lengkap dan {{group}} yang tepat. Jika tidak ada kecocokan, sistem akan memberi tahu bahwa {{member}} tidak ditemukan.',
    totalLabel: 'TOTAL',
    backToDashboard: 'Kembali ke Dasbor',
    product: 'Produk',
    productAndOrganization: 'Produk dan {{organization}}',
    fundingCodeRequired: 'Kode pendanaan diperlukan untuk kampanye ini.',
    orderWindowClosed: 'Pesanan ditutup. Tanggal akhir produk ini telah lewat.',
    orderRedirecting: 'Pesanan berhasil dibuat. Mengalihkan ke pembayaran...',
    itemAddedToCart: 'Item ditambahkan ke keranjang.',
    sportsHousePlaceholder: 'Rumah Olahraga / Tim',
    sportsHouseOptional: 'Rumah Olahraga / Tim (opsional)',
    hi: "Hai, {{name}} 👋",
    familyNextStep: "Inilah yang perlu dilakukan selanjutnya untuk keluarga Anda.",
    orderNow: "Pesan Sekarang",
    browseAll: "Lihat semua",
    openLabel: "Buka:",
    closeLabel: "Tutup:",
    productCount: "{{count}} Produk",
    recentOrders: "Pesanan Terbaru",
    viewAll2: "Lihat semua",
    track: "Lacak",
    myCampaigns: "Kampanye Saya",
    browseCampaigns: "Lihat kampanye aktif di seluruh grup yang Anda ikuti",
    browseCampaignsDesc: "Lacak kampanye terbuka, lihat produk yang ditugaskan, dan langsung ke pemesanan untuk organisasi yang terhubung ke akun Anda.",
    kpiTotal: "Total",
    kpiActive: "Aktif",
    kpiClosed: "Ditutup",
    viewOrders: "Lihat Pesanan",
    studentsCount: "Siswa ({{count}})",
    availableProducts: "Produk Tersedia",
    checkout: "Checkout",
    checkoutMulti: "Checkout Multi-Grup",
    checkoutDesc: "Tinjau item Anda dan selesaikan pembelian Anda.",
    checkoutMultiDesc: "Kelola produk dari beberapa grup dan selesaikan semuanya dalam satu checkout yang aman.",
    continueShopping: "Lanjutkan Belanja",
    emptyCart: "Keranjang Anda kosong",
    emptyCartDesc: "Lihat kampanye yang tersedia dan tambahkan item ke keranjang Anda.",
    browseCampaignsBtn: "Lihat Kampanye",
    checkoutSuccess: "Checkout berhasil. Semua item diproses dengan ID keranjang yang sama.",
    studentCount: "{{count}} Siswa",
    addStudent: "Tambah Siswa",
    classLabel2: "Kelas",
    optionsAria: "Opsi",
    noStudentsLinked: "Belum ada siswa yang ditautkan ke sekolah ini.",
    pmOnlinePayment: "Pembayaran Online",
    pmVoucher: "Kode Voucher",
    pmQrVoucher: "Voucher QR",
    pmManualTransfer: "Transfer Bank Manual",
    manualPaymentSelected: "Pembayaran manual dipilih. Pesanan akan dikirim untuk persetujuan sebelum pembayaran dikonfirmasi.",
    qrVoucherCode: "Kode Voucher QR",
    timeDays: "{{n}} hari",
    timeHours: "{{n}} jam",
    timeMinutes: "{{n}} min",
    productCode: "Kode: {{value}}",
    productMaterial: "Bahan: {{value}}",
    productWeight: "Berat: {{value}}",
    shortSleevePrice: "Harga Lengan Pendek: {{value}}",
    longSleevePrice: "Harga Lengan Panjang: {{value}}",
    colorsLabel: "Warna: {{value}}",
    deadlineLabel: "Tenggat: {{value}}",
    ordersClosed: "Pesanan ditutup.",
    sportsHouseRequired: "Silakan pilih rumah olahraga untuk setiap {{member}}.",
    addMemberAction: "+ Tambah {{member}}",
    addMemberGroup: "+ Tambah {{member}} / {{group}}",

    // ParentOrders page
    ordersTitle: "Pesanan",
    ordersSubtitle: "Lacak dan bayar pesanan Anda.",
    filterAll: "Semua",
    filterToPay: "Belum Dibayar",
    filterPaid: "Dibayar",
    loadingOrders: "Memuat pesanan Anda…",
    nothingToPay: "Tidak ada yang perlu dibayar",
    noPaidOrders: "Tidak ada pesanan yang dibayar",
    noOrdersYet: "Belum ada pesanan",
    ordersEmptyDesc: "Pesanan yang Anda buat akan muncul di sini dengan status langsung.",
    tryDifferentFilter: "Coba filter lain untuk melihat lebih banyak pesanan.",
    paying: "Membayar...",
    payBtn: "Bayar",
    unableToLoadOrders: "Tidak dapat memuat pesanan Anda.",
    unableToInitPayment: "Tidak dapat memulai pembayaran online.",
    // ParentHome
    homeUnableToLoad: "Tidak dapat memuat beranda Anda.",
    homeNoActiveCampaigns: "Tidak ada kampanye aktif",
    homeNoProductsYet: "Belum ada produk tersedia",
    homeNoProductsDesc: "Kampanye baru akan muncul di sini setelah sekolah Anda menerbitkannya.",
    homeNoProductsDesc2: "Sekolah Anda telah menerbitkan kampanye tetapi belum menambahkan produk. Periksa kembali segera!",
    // ParentCampaigns
    unableToLoadCampaigns: "Tidak dapat memuat kampanye Anda.",
    loadingCampaigns: "Memuat kampanye...",
    noCampaignsAvailable: "Tidak ada kampanye tersedia",
    noCampaignsAvailableDesc: "Organisasi yang Anda tautkan belum memiliki kampanye aktif atau ditutup.",
    // ParentCart
    orderCreatedPayment: "Pesanan dibuat. Melanjutkan ke pembayaran...",
    unableToInitPaymentRetry: "Tidak dapat memulai pembayaran online. Anda dapat mencoba lagi dari halaman resi.",
    orderCreatedComplete: "Pesanan dibuat. Selesaikan pembayaran dari halaman resi.",
    cartSubmitted: "Keranjang berhasil dikirim.",
    unableToCheckoutCart: "Tidak dapat checkout keranjang.",
    removeItemAria: "Hapus item",
    // ParentReceipt
    unableToLoadReceipt: "Tidak dapat memuat resi.",
    loadingReceipt: "Memuat resi...",
    paymentCompletedSummary: "Pembayaran selesai. Ini adalah ringkasan pesanan Anda.",
    unableToFindOrgPaymentLink: "Tidak dapat menemukan tautan pembayaran organisasi untuk pesanan ini.",
    unableToStartOnlinePayment: "Tidak dapat memulai pembayaran online.",
    unableToGeneratePdf: "Tidak dapat membuat PDF faktur.",
    // ParentOrder / ParentOrderEdit
    unableToLoadProducts: "Tidak dapat memuat produk.",
    unableToLoadChildData: "Tidak dapat memuat data anak.",
    unableToLoadOrderItems: "Tidak dapat memuat item pesanan.",
    orderNotFound: "Pesanan dibuat, tetapi ID pesanan tidak ditemukan. Silakan periksa dasbor Anda.",
    loadingOrderForm: "Memuat formulir pesanan...",
    exampleOrderNo: "mis. ABC-2027",
    selectSavedMember: "Pilih {{member}} tersimpan (opsional)",
    lookingUpRecords: "Memeriksa catatan sekolah untuk {{name}}...",
    thisMember: "anggota ini",
    unableToLoadOrder: "Tidak dapat memuat pesanan.",
    // ParentCartReceipt
    loadingCartReceipt: "Memuat resi keranjang...",
    unableToLoadCartReceipt: "Tidak dapat memuat resi keranjang.",
    paymentOrderSummary: "Ringkasan Pembayaran / Pesanan",
    cartReceiptTitle: "Resi keranjang",
    onePaymentAllSchools: "Satu pembayaran untuk semua sekolah",
    checkoutComplete: "Checkout selesai",
    aggregateCartDesc: "Semua pesanan di keranjang Anda ditanggung oleh satu pembayaran.",
    allOrdersProcessed: "Semua pesanan di keranjang ini diproses bersamaan.",
    backToCart: "Kembali ke keranjang",
    cartIdLabel: "ID Keranjang",
    overallTotal: "Total keseluruhan",
    paidBy: "Dibayar Oleh",
    groupsInCart: "Grup dalam keranjang ini",
    groupsInCartDesc: "Pesanan dikelompokkan berdasarkan grup untuk peninjauan yang lebih mudah.",
    orderColon: "Pesanan: {{number}}",
    orderCount: "{{count}} pesanan",
    orgTotal: "Total {{organization}}",
    sizeLabel: "Ukuran {{size}}",
    unitCount: "{{count}} unit",
    paymentRequired: "Pembayaran diperlukan",
    completeOnlinePayment: "Selesaikan pembayaran online Anda",
    pendingPaymentDesc: "Pesanan Anda telah dibuat tetapi pembayaran masih tertunda. Klik Bayar Sekarang untuk melanjutkan ke gerbang pembayaran.",
    initializingPayment: "Memulai pembayaran...",
    payNowBtn: "Bayar Sekarang",
    nextStep: "Langkah berikutnya",
    continueBrowsingOrDashboard: "Lanjutkan menjelajah atau kembali ke dasbor",
    cartCompleteDesc: "Keranjang ini lengkap. Anda dapat kembali ke dasbor untuk menambahkan keranjang lain.",
    openCart: "Buka keranjang",
    paymentGatewayError: "Gerbang pembayaran tidak mengembalikan URL pembayaran. Silakan coba lagi atau hubungi dukungan.",
    unableToInitOnlinePayment: "Tidak dapat memulai pembayaran online. Silakan coba lagi.",
    pmOrgSponsored: "Ditanggung Organisasi",
    pmManual: "Pembayaran Manual",
    pmCash: "Tunai",
    pmBankTransfer: "Transfer Bank",
    pmCheque: "Cek",
    pmComplimentary: "Gratis / FOC",
    psParent: "Orang Tua",
    psOrganization: "Organisasi",
    psManual: "Manual",
    psComplimentary: "Gratis",
    // TaskList
    goodMorning: "Selamat Pagi",
    goodAfternoon: "Selamat Siang",
    goodEvening: "Selamat Malam",
    taskOpen: "Buka",
    taskClosed: "Tutup",
    daysLeftOne: "{{days}} hari lagi",
    daysLeftMany: "{{days}} hari lagi",
    activeTasks: "Tugas Aktif",
    pendingOrders: "Pesanan Tertunda",

  },
  messages: {
    saveSuccess: 'Catatan berhasil disimpan.',
    updateSuccess: 'Perubahan berhasil diperbarui.',
    requiredWarning: 'Silakan lengkapi semua kolom wajib.',
    saveError: 'Tidak dapat menyimpan catatan. Silakan coba lagi.',
    csvImportInfo: 'Impor CSV berhasil diselesaikan.',
    loadNotificationsError: 'Tidak dapat memuat notifikasi. Silakan coba lagi.',
    updateNotificationError: 'Tidak dapat memperbarui notifikasi. Silakan coba lagi.',
    markAllError: 'Tidak dapat menandai semua notifikasi. Silakan coba lagi.',
    archiveError: 'Tidak dapat mengarsipkan notifikasi. Silakan coba lagi.',
    updateSettingsError: 'Tidak dapat memperbarui pengaturan notifikasi. Silakan coba lagi.',
    loadInvoiceError: 'Tidak dapat memuat faktur. Silakan coba lagi.',
    loadInvoicePdfError: 'Tidak dapat memuat PDF faktur. Silakan coba lagi.',
  },
  rejectOrder: {
    title: 'Tolak Pesanan',
    provideReason: 'Silakan berikan alasan',
    reason: "Alasan",
    reasonRequired: "Alasan diperlukan.",
  },
  funding: {
    addSourceHint: 'Tambahkan sumber pendanaan untuk kampanye ini agar pesanan dapat disponsori atau didanai pihak ketiga.',
    addFirstSource: 'Tambah Sumber Pertama',
    editSourceAria: 'Sunting sumber pendanaan',
    deleteSourceAria: 'Hapus sumber pendanaan',
    usageDescription: 'Pesanan yang menggunakan sumber pendanaan ini akan ditampilkan di sini.',
  },  org: {
    adminsTitle: "Administrator Organisasi",
    noMembersImported: "Belum ada anggota diimpor.",
    addLogo: "Tambah Logo",
    uploadLogo: "Unggah Logo",
    dismiss: "Tutup",
    payoutAccounts: "Akun Pembayaran",
    clickToUploadLogo: "Klik untuk mengunggah logo",
    orgTypeSchool: "Sekolah",
    orgTypeClub: "Klub",
    orgTypeAssociation: "Asosiasi",
    orgTypeNgo: "NGO",
    orgTypeCommunity: "Komunitas",
    orgTypeCompany: "Perusahaan",
    malaysianBank: "Akun Bank Malaysia",
    paypal: "Akun PayPal",
    noPayouts: "Belum Ada Akun Pembayaran",
    deletePayout: "Hapus Akun Pembayaran",
    noSpacesDashes: "Tanpa spasi atau tanda hubung",
    idNric: "NRIC / MyKad",
    idPassport: "Paspor",
    idBrn: "Registrasi Bisnis (BRN)",
    currencyMyr: "Ringgit Malaysia (RM)",
    currencyUsd: "Dolar AS (USD)",
    currencySgd: "Dolar Singapura (SGD)",
    autofillPh: "Biarkan kosong untuk mengisi otomatis",
    accountEmailPh: "account@domain.com",
    dashDesc: "Kelola kampanye, anggota, pesanan, dan laporan organisasi Anda.",
    loadingMetrics: "Memuat metrik ruang kerja...",
    noCampaigns: "Belum ada kampanye dibuat.",
    createFirstCampaign: "Buat kampanye pertama Anda untuk mulai menerima pesanan anggota.",
    noOrders: "Belum ada pesanan.",
    ordersHint: "Pesanan akan muncul di sini saat anggota membeli dari kampanye yang diterbitkan.",
    membersTitle: "Anggota Organisasi",
    membersDesc: "Lihat dan kelola anggota organisasi Anda.",
    searchMembersPh: "Cari anggota berdasarkan nama atau email...",
    loadingMembers: "Memuat anggota...",
    noMembers: "Tidak ada anggota ditemukan.",
    inviteHint: "Undang anggota tim atau pengguna ke organisasi Anda.",
    member: "Anggota",
    addMember: "Tambah Anggota Organisasi",
    emailAddress: "Alamat Email",
    emailPh: "member@example.com",
    reportsTitle: "Laporan Organisasi",
    reportsDesc: "Analitik keuangan, penjualan, dan kinerja kampanye.",
    loadingReports: "Menghasilkan metrik laporan...",
    performanceBreakdown: "Rincian Kinerja",
    performanceDesc: "Metrik kinerja kampanye terperinci untuk organisasi Anda.",
    ordersTitle: "Pesanan Organisasi",
    ordersDesc: "Lihat pesanan yang dibuat anggota di seluruh kampanye Anda.",
    searchOrdersPh: "Cari berdasarkan ID Pesanan atau nama pembeli...",
    loadingOrders: "Memuat pesanan...",
    navigation: "Navigasi",
    allCampaigns: "Semua Kampanye",
    createCampaign: "Buat Kampanye",
    loadingOrg: "Memuat organisasi…",
    accessDenied: "Akses Ditolak",
    accessDeniedDesc: "Akses ditolak. Akun Anda tidak dapat menggunakan modul Verifikasi Organisasi.",
    campaignYear: "Tahun Kampanye",
    selectAllOrders: "Pilih semua pesanan ({{count}})",
    groupLabel: "Grup",
    orderQueue: "Antrean Pesanan",
    showingOf: "Menampilkan {{shown}} dari {{total}} pesanan pada filter saat ini",
    searchOrderPh: "Cari pesanan, pembeli, kelas, ukuran, jumlah",
    allStatus: "Semua Status",
    paidOnline: "Dibayar Online",
    allTypes: "Semua Jenis",
    saveOrder: "Simpan Pesanan",
    allOrders: "Semua",
    pickHeader: "Pilih",
    memberNameWith: "Nama {{member}}",
    noActiveProducts: "Tidak ada produk aktif yang tersedia untuk organisasi ini",
    awaitingApprovalStatus: "Menunggu Persetujuan",
    termStudent: "Siswa",
    termClass: "Kelas",
    termClasses: "Kelas",
    termParentOnline: "Orang Tua Online",
    termAdminAssisted: "Dibantu Admin",
    termMember: "Anggota",
    termOnlineBuyer: "Pembeli Online",
    termCommittee: "Komite",
    termDepartment: "Departemen",
    termGroup: "Grup",
    termTeam: "Tim",
    termEmployee: "Karyawan",
    termVolunteer: "Relawan",
    studentNameHeader2: "Nama Siswa",
    sportsHouseHeader2: "Rumah Olahraga",
    createAssistedOrder: "Buat Pesanan Berbantu",
    assistedModeDesc: "Mode checkout berbantu untuk pembeli offline atau pembelian berbantu langsung.",
    selectProduct: "Pilih Produk",
    studentName: "Nama Siswa",
    phoneNumber: "Nomor Telepon",
    address: "Alamat",
    size: "Ukuran",
    quantity: "Jumlah",
    classLabel: "Kelas",
    stockSuffix: "{{size}} ({{stock}} stok)",
    orderHeader2: "Pesanan",
    buyerHeader2: "Pembeli",
    qtyHeader2: "Jml",
    amountHeader: "Jumlah",
    typeHeader: "Jenis",
    lastImportLabel: "Impor terakhir:",
    noStudentsImported: "Belum ada siswa diimpor.",
    paidOrdersKpi: "Pesanan Dibayar",
    pendingOrdersKpi: "Pesanan Menunggu",
    studentsOrderedOfShort: "Siswa memesan / Total siswa",
    membersKpi: "Anggota",
    teacherRole: "Guru",
    administratorRole: "Administrator",
    pendingSetup: "Menunggu Pengaturan",
    searchMembersPh: "Cari anggota...",
    noMembersFound: "Tidak ada anggota ditemukan",
    uploadCsvHint: "Unggah CSV siswa Anda untuk memulai.",
    memberImportDesc: "Unggah daftar anggota Anda dari file CSV, atau unduh templat untuk diisi terlebih dahulu.",
    directoryDesc: "Direktori anggota organisasi dan akun terdaftar.",
    orgUploadCsvHint: "Unggah CSV anggota Anda untuk memulai.",
    statusActive: "aktif",
    fewerThanDb: "CSV yang diunggah berisi lebih sedikit {{members}} daripada database Anda saat ini.",
    newMembersToImport: "{{members}} baru untuk diimpor:",
    previousReplaced: "{{members}} sebelumnya diganti:",
    labelsReady: "{{count}} label siap untuk dicetak",
    allOrdered: "Semua siswa telah memesan",
    readyForApproval: "Siap untuk persetujuan",
    readyForApprovalDesc: "Daftar siswa divalidasi. Kirim kampanye ini untuk ditinjau.",
    awaitingApproval: "Menunggu persetujuan",
    awaitingApprovalDesc: "{{name}} telah dikirim dan menunggu tinjauan Super Admin.",
    approvedReady: "Disetujui — siap diterbitkan",
    approvedReadyDesc: "{{name}} disetujui. Terbitkan untuk membuka pesanan.",
    closingSoon: "Kampanye akan ditutup",
    closingSoonDesc: "{{name}} ditutup dalam {{days}} hari.",
    sendRemindersHint: "Kirim pengingat untuk mendorong pesanan.",
    noDescription: "Tanpa deskripsi",
    reportSuffix: "Laporan",
    dashTitle: "Ringkasan operasi sekolah.",
    setupComplete: "Pengaturan Selesai",
    campaignRunning: "Kampanye Berjalan",
    runningCampaign: "KAMPANYE BERJALAN",
    published: "Diterbitkan",
    opened: "Dibuka:",
    closes: "Ditutup:",
    daysLeft: "({{days}} hari lagi)",
    orderProgress: "Kemajuan Pesanan",
    studentsOrderedOf: "Siswa memesan / Total siswa:",
    studentsNeedOrder: "{{count}} siswa masih perlu memesan",
    viewCampaign: "Lihat Kampanye",
    sendReminders: "Kirim Pengingat",
    campaignTimeline: "Garis Waktu Kampanye",
    tlCreated: "Dibuat",
    tlSubmitted: "Dikirim",
    tlApproved: "Disetujui",
    tlPublished: "Diterbitkan",
    ordersOpen: "Pesanan Dibuka",
    distribution: "Distribusi",
    kpiStudents: "SISWA",
    kpiParentsLinked: "ORANG TUA TERHUBUNG",
    kpiOrders: "PESANAN",
    kpiNotOrdered: "BELUM MEMESAN",
    actionRequired: "Tindakan Diperlukan",
    studentsHaventOrdered: "{{count}} siswa belum memesan",
    daysUntilClosing: "{{days}} hari sebelum ditutup ({{date}}).",
    recentOrders: "Pesanan Terbaru",
    viewAll: "Lihat semua",
    orderHeader: "PESANAN",
    buyerHeader: "PEMBELI",
    classHeader: "KELAS",
    qtyHeader: "JML",
    statusHeader: "STATUS",
    closesOn: "Ditutup {{date}}",
    itemsCount: "{{count}} item",
    viewAction: "Lihat",
    membersTitle: "Anggota",
    membersDesc: "Kelola administrator sekolah dan direktori anggota Anda.",
    schoolAdmins: "Administrator Sekolah",
    schoolAdminsDesc: "Orang yang mengelola akun sekolah ini.",
    addAdministrator: "Tambah Administrator",
    owner: "Pemilik",
    active: "Aktif",
    studentImport: "Impor Siswa",
    studentImportDesc: "Unggah daftar siswa Anda dari file CSV, atau unduh templat untuk diisi terlebih dahulu.",
    lastImport: "IMPOR TERAKHIR",
    never: "Tidak Pernah",
    downloadCsvTemplate: "Unduh Templat CSV",
    uploadCsv: "Unggah CSV",
    schoolMembers: "Anggota Sekolah",
    schoolMembersDesc: "Siswa, orang tua, dan guru. Anggota dibuat otomatis melalui impor CSV, klaim orang tua, dan undangan guru.",
    totalKpi: "TOTAL",
    studentsKpi: "SISWA",
    inactiveKpi: "TIDAK AKTIF",
    filterStudents: "Siswa",
    filterInactive: "Tidak Aktif",
    exportCsv: "Ekspor CSV",
    importCsv: "Impor CSV",
    nameHeader: "NAMA",
    classDeptHeader: "KELAS / DEPT",
    sportsHouseHeader: "RUMAH OLAHRAGA",
    parentLinkedHeader: "ORANG TUA TERHUBUNG",
    actionsHeader: "TINDAKAN",
    notLinked: "Tidak terhubung",
    linked: "Terhubung",
    showingMembers: "Menampilkan {{from}}–{{to}} dari {{total}} anggota",
    rowsPerPage: "Baris per halaman:",
    previous: "Sebelum",
    next: "Berikutnya",
    reportsTitle: "Laporan Kampanye",
    reportsDesc: "Analisis catatan pesanan, pembayaran, dan pengiriman dalam konteks kampanye.",
    campaignLabel: "KAMPANYE",
    overview: "RINGKASAN",
    totalEnrolled: "Total terdaftar",
    acrossAllCampaigns: "Di seluruh kampanye",
    paymentConfirmed: "Pembayaran dikonfirmasi",
    awaitingPayment: "Menunggu pembayaran",
    completionDelivery: "PENYELESAIAN & PENGIRIMAN PESANAN",
    completionPct: "PERSENTASE PENYELESAIAN %",
    paidAmount: "JUMLAH DIBAYAR",
    collected: "Dikumpulkan",
    inProduction: "DALAM PRODUKSI",
    beingMade: "Sedang dibuat",
    packing: "PENGEMASAN",
    beingPacked: "Sedang dikemas",
    inDelivery: "DALAM PENGIRIMAN",
    onTheWay: "Dalam perjalanan",
    completed: "SELESAI",
    delivered: "Dikirim",
    allStudents: "Semua Siswa",
    notLinkedLabel: "Tidak Terhubung",
    orderedLabel: "Telah Memesan",
    pendingLabel: "Menunggu",
    studentNameHeader: "NAMA SISWA",
    parentStatusHeader: "STATUS ORANG TUA",
    orderStatusHeader: "STATUS PESANAN",
    lastOrderHeader: "PESANAN TERAKHIR",
    notOrdered: "Belum Memesan",
    showingStudents: "Menampilkan {{from}}–{{to}} dari {{total}} siswa",
    opsTitle: "Operasi Kampanye",
    opsDesc: "Pesanan, produksi, pengemasan, dan pengiriman dikelola dari konteks kampanye.",
    printLabelDisabled: "Label cetak dinonaktifkan untuk sekolah ini. Hubungi Super Admin.",
    openLabelPrint: "Buka Pusat Cetak Label",
    totalOrdersKpi: "TOTAL PESANAN",
    onlineKpi: "ONLINE",
    manualKpi: "MANUAL",
    printLabelsKpi: "CETAK LABEL",
    orgBadge: "ORGANISASI",
    unableToLoadVerification: "Tidak dapat memuat verifikasi {{member}}.",
    reminderSentTo: "Pengingat dikirim ke {{count}} {{members}}.",
    labelStudent: "Siswa",
    labelStudents: "Siswa",
    labelMember: "Anggota",
    labelMembers: "Anggota",
    labelEmployee: "Karyawan",
    labelEmployees: "Karyawan",
    labelVolunteer: "Relawan",
    labelVolunteers: "Relawan",
    labelPrincipal: "Kepala Sekolah",
    labelPresident: "Presiden",
    labelManager: "Manajer",
    labelOwner: "Pemilik",
    labelCoordinator: "Koordinator",
    labelAdministrator: "Admin",
    memberCenterWith: "Pusat {{member}} — {{name}}",
    verifyImportWith: "Impor dan validasi {{members}}, lalu kirim pengingat berdasarkan grup atau kohort.",
    uploadMemberListWith: "Unggah Daftar {{label}} atau Data Organisasi",
    notifyContactsWith: "Beri tahu kontak untuk {{members}} yang belum memesan.",
    totalWithLabel: "Total {{members}}",
    directoryWith: "Direktori {{member}}",
    noWith: "Tidak ada {{members}} ditemukan",
    uploading: "Mengunggah...",
    loadingVerification: "Memuat data verifikasi...",
    filterBy: "Filter {{type}}:",
    breakdownBy: "Rincian per {{type}}",
    progressPct: "Kemajuan {{pct}}%",
    uncategorized: "Tidak Dikategorikan",
    noGroup: "Tanpa Grup",
    importResult: "Hasil Impor",
    rowErrors: "Kesalahan Baris",
    typeAdmin: "Admin {{type}}",
    orgTypeLabel: "Jenis Organisasi",
    descriptionLabel: "Deskripsi",
    contactMobileNumber: "Nomor Ponsel",
    settingsDesc: "Kelola profil, branding, dan akun penyelesaian pembayaran ruang kerja Anda.",
    logoUploadDesc: "Unggah logo resmi Anda untuk ditampilkan di header portal, kampanye, dan resi.",
    logoRecommendation: "Disarankan: Gambar persegi (mis. 500x500px). Format: PNG, JPG, WebP hingga 2MB.",
    exportCsvReport: "Ekspor Laporan CSV",
    reportsAuditNote: "Semua laporan keuangan diaudit otomatis dan dibatasi ke ruang kerja organisasi Anda.",
    memberCenter: "Pusat Anggota",
    verifyImportDesc: "Impor dan validasi anggota, lalu kirim pengingat berdasarkan grup atau kohort.",
    uploadMemberList: "Unggah Daftar Anggota atau Data Organisasi",
    requiredColumns: "Kolom wajib: Nama, Kelas dan Rumah Olahraga. Opsional: ID Anggota, Jenis Kelamin, KTP, Catatan.",
    downloadSampleCsv: "Unduh CSV Contoh",
    dragDrop: "Seret dan lepas file Anda di sini",
    orChooseFile: "atau pilih file",
    chooseFile: "Pilih File",
    uploadFile: "Unggah File",
    sendOrderReminders: "Kirim Pengingat Pesanan",
    notifyContacts: "Beri tahu kontak untuk anggota yang belum memesan.",
    allGroups: "Semua Grup",
    sendReminders: "Kirim Pengingat",
    orderedLabel: "Telah Memesan",
    notOrderedLabel: "Belum Memesan",
    progress: "Kemajuan",
    verificationOverview: "Ringkasan Verifikasi",
    viewBy: "Lihat Berdasarkan:",
    group: "Grup",
    category: "Kategori",
    filterGroup: "Filter Grup:",
    breakdownByGroup: "Rincian per Grup",
    memberDirectory: "Direktori Anggota",
    nameHeader: "Nama",
    ordersHeader: "Pesanan",
    parentHeader: "Orang Tua",
    noMembersFound: "Tidak ada anggota ditemukan",
    noMembersHint: "Coba grup lain atau impor data organisasi untuk mengisi direktori ini.",
    orgLogo: "Logo Organisasi",
    orgName: "Nama Organisasi / Klub",
    addItem: "Tambah Item",
    addPayoutHint: "Klik \"+ Tambah Akun Pembayaran\" di atas untuk mengirim akun bank atau PayPal Anda untuk penyelesaian pembayaran.",
    orgProfile: "Profil Organisasi",
    orgCampaigns: "Kampanye Organisasi",
    recentCampaigns: "Kampanye terbaru yang dibuat oleh organisasi Anda",
    recentOrders: "Pesanan Anggota Terbaru",
    recentOrdersDesc: "Pembelian dan pembayaran anggota terbaru",
    dashSettings: "Pengaturan Organisasi",
    sending: "Mengirim...",
    schoolProfile: "Profil Sekolah",
    schoolLogo: "Logo Sekolah",
    changeLogo: "Ubah Logo",
    schoolName: "Nama Sekolah",
    addPayoutAccount: "Tambah Akun Pembayaran",
    payoutDesc: "Kami memerlukan Anda mengirimkan detail akun pembayaran untuk verifikasi dan penyelesaian pembayaran.",
    primary: "Utama",
    currencyColon: "Mata Uang:",
    addBankAccount: "Tambah Akun Bank",
    bank: "Bank",
    accountNumber: "Nomor akun",
    beneficiaryName: "Nama penerima",
    idType: "Jenis ID",
    idNumber: "Nomor ID",
    currency: "Mata Uang",
    addPaypal: "Tambah Akun PayPal",
    paypalEmail: "Email PayPal",
    accountHolderName: "Nama Pemegang Akun",
    saving: "Menyimpan...",
    back: "Kembali",
  },
  campaign: {
    searchCampaignsPh: "Cari kampanye...",
    allStatus: "Semua Status",
    noCampaignsYet: "Belum ada kampanye",
    viewCampaign: "Lihat kampanye",
    previewCampaign: "Pratinjau kampanye",
    moreActions: "Tindakan lainnya",
    studentListRequired: "Daftar siswa diperlukan",
    scanQr: "Pindai kode QR untuk membuka toko kampanye",
    campaignDetails: "Detail Kampanye",
    orderCutoff: "Batas Pesanan",
    paymentDue: "Jatuh Tempo Pembayaran",
    distributionDate: "Tanggal Distribusi",
    distributionMethod: "Metode Distribusi",
    collectionPoint: "Titik Pengambilan",
    allocation: "Alokasi",
    quantityTarget: "Target Jumlah",
    minMaxOrder: "Min / Maks Pesanan",
    noItems: "Belum ada item",
    noPayments: "Belum ada pembayaran",
    qrPasses: "Tiket QR",
    qrDesc: "Kode QR dibuat otomatis setelah pembayaran berhasil. Satu QR per pesanan.",
    noQr: "Belum ada tiket QR dibuat",
    noQrHint: "Kode QR muncul setelah pesanan dibayar",
    productionDesc: "Pantau status produksi dan pemrosesan batch di sini.",
    packingDesc: "Kelola daftar pengemasan dan operasi pengemasan batch di sini.",
    delivery: "Pengiriman / Pengambilan",
    deliveryDesc: "Pantau pengiriman, pengambilan, dan distribusi di sini.",
    groupEventsDesc: "Acara pesanan kelompok untuk organisasi Anda",
    createFirstDesc: "Buat kampanye pesanan kelompok pertama Anda",
    studentCsvHint: "Unggah dan validasi CSV siswa sebelum mengirim kampanye ini untuk persetujuan.",
    sku: "SKU:",
    itemsCount: "Item ({{count}})",
    ordersCount: "Pesanan ({{count}})",
    orderHash: "Pesanan #",
    duplicate: "Duplikat",
    totalItemsLabel: "Total Item",
  },

  school: {
    membersTitle: "Anggota",
    membersDesc: "Kelola administrator sekolah dan direktori anggota Anda.",
    searchMembersPh: "Cari anggota...",
    reportsTitle: "Laporan Kampanye",
    reportsDesc: "Analisis catatan pesanan, pembayaran, dan pengiriman dalam konteks kampanye.",
    paidOrdersKpi: "Pesanan Dibayar",
    pendingOrdersKpi: "Pesanan Menunggu",
    studentsOrderedOfShort: "Siswa memesan / Total siswa",
    teacherRole: "Guru",
    administratorRole: "Administrator",
    pendingSetup: "Menunggu Pengaturan",
    noMembersFound: "Tidak ada anggota ditemukan",
    uploadCsvHint: "Unggah CSV siswa Anda untuk memulai.",
    memberImportDesc: "Unggah daftar anggota Anda dari file CSV, atau unduh templat untuk diisi terlebih dahulu.",
    directoryDesc: "Direktori anggota organisasi dan akun terdaftar.",
    orgUploadCsvHint: "Unggah CSV anggota Anda untuk memulai.",
    statusActive: "aktif",
    fewerThanDb: "CSV yang diunggah berisi lebih sedikit {{members}} daripada database Anda saat ini.",
    newMembersToImport: "{{members}} baru untuk diimpor:",
    previousReplaced: "{{members}} sebelumnya diganti:",
    labelsReady: "{{count}} label siap untuk dicetak",
    allOrdered: "Semua siswa telah memesan",
    readyForApproval: "Siap untuk persetujuan",
    readyForApprovalDesc: "Daftar siswa divalidasi. Kirim kampanye ini untuk ditinjau.",
    awaitingApproval: "Menunggu persetujuan",
    awaitingApprovalDesc: "{{name}} telah dikirim dan menunggu tinjauan Super Admin.",
    approvedReady: "Disetujui — siap diterbitkan",
    approvedReadyDesc: "{{name}} disetujui. Terbitkan untuk membuka pesanan.",
    closingSoon: "Kampanye akan ditutup",
    closingSoonDesc: "{{name}} ditutup dalam {{days}} hari.",
    sendRemindersHint: "Kirim pengingat untuk mendorong pesanan.",
    noDescription: "Tanpa deskripsi",
    reportSuffix: "Laporan",
    dashTitle: "Ringkasan operasi sekolah.",
    setupComplete: "Pengaturan Selesai",
    campaignRunning: "Kampanye Berjalan",
    runningCampaign: "KAMPANYE BERJALAN",
    published: "Diterbitkan",
    opened: "Dibuka:",
    closes: "Ditutup:",
    daysLeft: "({{days}} hari lagi)",
    orderProgress: "Kemajuan Pesanan",
    studentsOrderedOf: "Siswa memesan / Total siswa:",
    studentsNeedOrder: "{{count}} siswa masih perlu memesan",
    viewCampaign: "Lihat Kampanye",
    sendReminders: "Kirim Pengingat",
    campaignTimeline: "Garis Waktu Kampanye",
    tlCreated: "Dibuat",
    tlSubmitted: "Dikirim",
    tlApproved: "Disetujui",
    tlPublished: "Diterbitkan",
    noActiveCampaignsDesc: "Buat kampanye untuk mulai menerima pesanan.",
    otherCampaigns: "Kampanye Lain",
    opensOn: "Dibuka {{date}}",
    ordersOpen: "Pesanan Dibuka",
    distribution: "Distribusi",
    kpiStudents: "SISWA",
    kpiParentsLinked: "ORANG TUA TERHUBUNG",
    kpiOrders: "PESANAN",
    kpiNotOrdered: "BELUM MEMESAN",
    actionRequired: "Tindakan Diperlukan",
    studentsHaventOrdered: "{{count}} siswa belum memesan",
    daysUntilClosing: "{{days}} hari sebelum ditutup ({{date}}).",
    recentOrders: "Pesanan Anggota Terbaru",
    viewAll: "Lihat semua",
    orderHeader: "PESANAN",
    buyerHeader: "PEMBELI",
    classHeader: "KELAS",
    qtyHeader: "JML",
    statusHeader: "STATUS",
    closesOn: "Ditutup {{date}}",
    itemsCount: "{{count}} item",
    viewAction: "Lihat",
    schoolAdmins: "Administrator Sekolah",
    schoolAdminsDesc: "Orang yang mengelola akun sekolah ini.",
    addAdministrator: "Tambah Administrator",
    owner: "Pemilik",
    active: "Aktif",
    studentImport: "Impor Siswa",
    studentImportDesc: "Unggah daftar siswa Anda dari file CSV, atau unduh templat untuk diisi terlebih dahulu.",
    lastImport: "IMPOR TERAKHIR",
    never: "Tidak Pernah",
    downloadCsvTemplate: "Unduh Templat CSV",
    uploadCsv: "Unggah CSV",
    schoolMembers: "Anggota Sekolah",
    schoolMembersDesc: "Siswa, orang tua, dan guru. Anggota dibuat otomatis melalui impor CSV, klaim orang tua, dan undangan guru.",
    totalKpi: "TOTAL",
    studentsKpi: "SISWA",
    inactiveKpi: "TIDAK AKTIF",
    filterStudents: "Siswa",
    filterInactive: "Tidak Aktif",
    exportCsv: "Ekspor CSV",
    importCsv: "Impor CSV",
    nameHeader: "Nama",
    classDeptHeader: "KELAS / DEPT",
    sportsHouseHeader: "RUMAH OLAHRAGA",
    parentLinkedHeader: "ORANG TUA TERHUBUNG",
    actionsHeader: "TINDAKAN",
    notLinked: "Tidak terhubung",
    linked: "Terhubung",
    showingMembers: "Menampilkan {{from}}–{{to}} dari {{total}} anggota",
    rowsPerPage: "Baris per halaman:",
    previous: "Sebelum",
    next: "Berikutnya",
    campaignLabel: "KAMPANYE",
    overview: "RINGKASAN",
    totalEnrolled: "Total terdaftar",
    acrossAllCampaigns: "Di seluruh kampanye",
    paymentConfirmed: "Pembayaran dikonfirmasi",
    awaitingPayment: "Menunggu pembayaran",
    completionDelivery: "PENYELESAIAN & PENGIRIMAN PESANAN",
    completionPct: "PERSENTASE PENYELESAIAN %",
    paidAmount: "JUMLAH DIBAYAR",
    collected: "Dikumpulkan",
    inProduction: "DALAM PRODUKSI",
    beingMade: "Sedang dibuat",
    packing: "PENGEMASAN",
    beingPacked: "Sedang dikemas",
    inDelivery: "DALAM PENGIRIMAN",
    onTheWay: "Dalam perjalanan",
    completed: "SELESAI",
    delivered: "Dikirim",
    allStudents: "Semua Siswa",
    notLinkedLabel: "Tidak Terhubung",
    orderedLabel: "Telah Memesan",
    pendingLabel: "Menunggu",
    studentNameHeader: "NAMA SISWA",
    parentStatusHeader: "STATUS ORANG TUA",
    orderStatusHeader: "STATUS PESANAN",
    lastOrderHeader: "PESANAN TERAKHIR",
    notOrdered: "Belum Memesan",
    showingStudents: "Menampilkan {{from}}–{{to}} dari {{total}} siswa",
    opsTitle: "Operasi Kampanye",
    opsDesc: "Pesanan, produksi, pengemasan, dan pengiriman dikelola dari konteks kampanye.",
    printLabelDisabled: "Label cetak dinonaktifkan untuk sekolah ini. Hubungi Super Admin.",
    openLabelPrint: "Buka Pusat Cetak Label",
    totalOrdersKpi: "TOTAL PESANAN",
    onlineKpi: "ONLINE",
    manualKpi: "MANUAL",
    printLabelsKpi: "CETAK LABEL",
    orgBadge: "ORGANISASI",
    createAssistedOrder: "Buat Pesanan Berbantu",
    assistedModeDesc: "Mode checkout berbantu untuk pembeli offline atau pembelian berbantu langsung.",
    selectProduct: "Pilih Produk",
    noActiveProducts: "Tidak ada produk aktif yang tersedia untuk organisasi ini",
    memberNameWith: "Nama {{member}}",
    saveOrder: "Simpan Pesanan",
    orderQueue: "Antrean Pesanan",
    showingOf: "Menampilkan {{shown}} dari {{total}} pesanan pada filter saat ini",
    searchOrderPh: "Cari pesanan, pembeli, kelas, ukuran, jumlah",
    allStatus: "Semua Status",
    paidOnline: "Dibayar Online",
    allTypes: "Semua Jenis",
    allOrders: "Semua",
    pickHeader: "Pilih",
    selectAllOrders: "Pilih semua pesanan ({{count}})",
    groupLabel: "Grup",
    awaitingApprovalStatus: "Menunggu Persetujuan",
    labelsReady: "{{count}} label siap untuk dicetak",
    teacherRole: "Guru",
    administratorRole: "Administrator",
    pendingSetup: "Menunggu Pengaturan",
    searchMembersPh: "Cari anggota...",
    noMembersFound: "Tidak ada anggota ditemukan",
    uploadCsvHint: "Unggah CSV siswa Anda untuk memulai.",
    memberImportDesc: "Unggah daftar anggota Anda dari file CSV, atau unduh templat untuk diisi terlebih dahulu.",
    directoryDesc: "Direktori anggota organisasi dan akun terdaftar.",
    orgUploadCsvHint: "Unggah CSV anggota Anda untuk memulai.",
    statusActive: "aktif",
    fewerThanDb: "CSV yang diunggah berisi lebih sedikit {{members}} daripada database Anda saat ini.",
    newMembersToImport: "{{members}} baru untuk diimpor:",
    previousReplaced: "{{members}} sebelumnya diganti:",
    lastImportLabel: "Impor terakhir:",
    noStudentsImported: "Belum ada siswa diimpor.",
    paidOrdersKpi: "Pesanan Dibayar",
    pendingOrdersKpi: "Pesanan Menunggu",
    studentsOrderedOfShort: "Siswa memesan / Total siswa",
    studentNameHeader2: "Nama Siswa",
    sportsHouseHeader2: "Rumah Olahraga",
    termStudent: "Siswa",
    termClass: "Kelas",
    termClasses: "Kelas",
    termParentOnline: "Orang Tua Online",
    termAdminAssisted: "Dibantu Admin",
    termMember: "Anggota",
    termOnlineBuyer: "Pembeli Online",
    termCommittee: "Komite",
    termDepartment: "Departemen",
    termGroup: "Grup",
    termTeam: "Tim",
    termEmployee: "Karyawan",
    termVolunteer: "Relawan",

    phoneNumber: "Nomor Telepon",
    address: "Alamat",
    size: "Ukuran",
    quantity: "Jumlah",
    stockSuffix: "{{size}} ({{stock}} stok)",
    orderHeader2: "Pesanan",
    buyerHeader2: "Pembeli",
    qtyHeader2: "Jml",
    amountHeader: "Jumlah",
    typeHeader: "Jenis",
    classLabel: "Kelas",
    studentName: "Nama Siswa",
    membersKpi: "Anggota",

    paymentMethod2: "Metode Pembayaran",
    manualPaymentReview: "Tinjauan Pembayaran Manual",
    schoolPaymentApproval: "Persetujuan Pembayaran Sekolah",
    orgPaymentConfirmation: "Konfirmasi Pembayaran Organisasi",
    printLabels2: "Cetak Label",
    queueFirstWorkflow: "Alur kerja antrean pertama: pilih catatan, pratinjau PDF, lalu konfirmasi cetak untuk log audit.",
    manualVerified: "Diverifikasi Manual",
    pending2: "Menunggu",
    pageOf: "Halaman {{page}} dari {{total}}",
    type2: "Jenis",
    name2: "Nama",
    adminsTitle: "Administrator Sekolah",
    campaign2: "Kampanye",
    overview2: "Ringkasan",

    statusActiveLabel: "Aktif",

    kpiParents: "Orang Tua",
    kpiEmployees: "Karyawan",
    kpiParticipants: "Peserta",
    kpiVolunteers: "Relawan",

    complimentary: "Gratis",
    notes: "Catatan",

  },
  term: {
    organization: "Organisasi",
    school: "Sekolah",
    company: "Perusahaan",
    club: "Klub",
    university: "Universitas",
    member: "Anggota",
    employee: "Karyawan",
    student: "Siswa",
    memberLower: "anggota",
    employeeLower: "karyawan",
    studentLower: "siswa",
    group: "Grup",
    class: "Kelas",
    department: "Departemen",
    committee: "Komite",
    faculty: "Fakultas",
    groupLower: "grup",
    classLower: "kelas",
    departmentLower: "departemen",
    committeeLower: "komite",
    facultyLower: "fakultas",
    groupPlaceholderClass: "mis. 1A",
    groupPlaceholderTeam: "mis. Tim Penjualan",
    groupPlaceholderCommittee: "mis. Komite Acara",
    groupPlaceholderFaculty: "mis. Fakultas Teknik",
    groupPlaceholderGeneric: "mis. Grup A",
  },
  campaignForm: {
    createCampaign: "Buat Kampanye",
    editCampaign: "Edit Kampanye",
    campaignApproved: "Kampanye (Disetujui)",
    blueprintSubtitle: "Pilih blueprint untuk memulai dengan cepat",
    formSubtitle: "Siapkan acara pemesanan grup Anda",
    chooseBlueprint: "Pilih Blueprint",
    chooseBlueprintDesc: "Pilih templat untuk mengonfigurasi kampanye Anda secara otomatis. Anda tetap dapat mengubah semuanya nanti.",
    orBlankCampaign: "Atau mulai dengan kampanye kosong",
    fromLabel: "Dari",
    usingBlueprint: "Menggunakan blueprint: {{label}}",
    change: "Ubah",
    bpBlank: "Kampanye Kosong",
    bpBlankDesc: "Mulai dari awal dengan pengaturan bawaan.",
    bpSportsWear: "Pakaian Olahraga & Atletik",
    bpSportsWearDesc: "Kaos, jersey, dan pakaian hari olahraga dengan variasi ukuran.",
    bpUniform: "Seragam & Perlengkapan Resmi",
    bpUniformDesc: "Set seragam standar dan perlengkapan resmi dengan ukuran standar.",
    bpMarathon: "Maraton / Fun Run",
    bpMarathonDesc: "Nomor balapan, kaus finisher, dan merchandise acara.",
    bpProductSale: "Penjualan Produk",
    bpProductSaleDesc: "Penjualan produk umum dengan pelacakan inventaris.",
    bpTicketing: "Tiket",
    bpTicketingDesc: "Tiket acara dengan harga berjenjang dan pengumpulan QR.",
    bpDonation: "Donasi",
    bpDonationDesc: "Penggalangan dana dengan pembayaran gratis dan akses terbuka.",
    bpMembership: "Keanggotaan",
    bpMembershipDesc: "Keanggotaan klub atau asosiasi dengan verifikasi anggota.",
    bpService: "Pemesanan Layanan",
    bpServiceDesc: "Pesan layanan atau janji temu dengan slot waktu.",
    bpProperty: "Roadshow Properti",
    bpPropertyDesc: "Daftar properti dan registrasi open house.",
    bpVehicle: "Promosi Kendaraan",
    bpVehicleDesc: "Penjualan kendaraan, test drive, dan kampanye promosi.",
    bpSportsWearName: "Kampanye Pakaian Atletik Hari Olahraga Tahunan",
    bpSportsWearDesc2: "Jersey tim resmi, kaos olahraga, dan perlengkapan atletik dengan pilihan ukuran.",
    bpUniformName: "Set Seragam & Pakaian Resmi 2026",
    bpUniformDesc2: "Set seragam standar, kemeja, dan pakaian resmi dengan ukuran standar.",
    bpMarathonName: "Maraton & Fun Run Tahunan 2026",
    bpMarathonDesc2: "Nomor balapan, kaos acara, medali finisher, dan pendaftaran fun run.",
    bpProductSaleName: "Penjualan Eksklusif Merchandise Resmi & Produk",
    bpProductSaleDesc2: "Merchandise resmi klub, pakaian, aksesori, dan item promosi.",
    bpTicketingName: "Makan Malam Gala & Tiket Acara Tahunan",
    bpTicketingDesc2: "Tiket acara, pas konser, dan tiket masuk dengan verifikasi pas QR.",
    bpDonationName: "Kampanye Penggalangan Dana Komunitas & Amal",
    bpDonationDesc2: "Kampanye penggalangan dana untuk inisiatif amal, proyek komunitas, dan donasi sukarela.",
    bpMembershipName: "Pendaftaran Keanggotaan Organisasi Tahunan 2026",
    bpMembershipDesc2: "Iuran keanggotaan tahunan klub, asosiasi, atau komunitas dan pendaftaran anggota.",
    bpServiceName: "Pemesanan Layanan Profesional & Janji Temu",
    bpServiceDesc2: "Pesan janji temu, sesi pelatihan, atau slot waktu fasilitas dengan reservasi terjadwal.",
    bpPropertyName: "Roadshow Properti Eksklusif & Acara Open House",
    bpPropertyDesc2: "Pendaftaran open house VIP, janji temu melihat unit, dan pemesanan roadshow.",
    bpVehicleName: "Promosi Peluncuran Kendaraan Baru & Test Drive",
    bpVehicleDesc2: "Pesan slot test drive, reservasi penawaran promosi, dan kunci harga peluncuran khusus.",
    lockedBanner: "Kampanye ini {{status}}. Pengeditan langsung terkunci.",
    lockedSubtitle: "Kampanye ini disetujui dan terkunci. Kirim permintaan perubahan untuk mengusulkan pengeditan.",
    lockedDesc: "Untuk mengubah harga, produk, stok, variasi, tanggal, atau gambar, kirim permintaan perubahan untuk ditinjau Admin Super. Kampanye langsung tetap tidak berubah sampai disetujui.",
    pendingRequest: "Permintaan perubahan sedang menunggu tinjauan",
    reasonLabel: "Alasan: {{reason}}",
    submittedStatus: "Dikirim {{date}} · Status: {{status}}",
    cancelRequest: "Batalkan permintaan",
    requestChange: "Minta Perubahan",
    submitChangeRequest: "Kirim Permintaan Perubahan",
    changeRequestDesc: "Buat perubahan Anda di formulir di bawah, lalu jelaskan alasannya. Kampanye langsung tidak akan berubah sampai Admin Super menyetujui.",
    changeReasonPh: "mis., Perlu menambah ukuran M dan menyesuaikan harga untuk kampanye yang disetujui",
    submitting: "Mengirim...",
    submitRequest: "Kirim Permintaan",
    campaignInfo: "Informasi Kampanye",
    required: "Diperlukan",
    campaignName: "Nama Kampanye",
    campaignNamePh: "mis., Hari Olahraga 2026",
    campaignType: "Jenis Kampanye",
    selectType: "Pilih jenis...",
    basePrice: "Harga Dasar",
    basePriceError: "Harga dasar diperlukan dan harus lebih dari RM 0.00",
    skuLabel: "SKU",
    skuPh: "mis., SD2026-TS",
    sleeveType: "Jenis Lengan",
    shortSleevePrice: "Harga Lengan Pendek (RM)",
    longSleevePrice: "Harga Lengan Panjang (RM)",
    ticketingTitle: "Konfigurasi Acara & Tiket",
    ticketingPreset: "Preset Tiket",
    venueLabel: "Tempat / Lokasi Acara",
    venuePh: "mis., Ballroom Utama / Streaming Online",
    tierLabel: "Kategori / Tingkat Tiket",
    tierPh: "mis., Pas Masuk VIP / Masuk Umum",
    ticketingNote: "Penukaran pas digital QR otomatis diaktifkan untuk pemegang tiket setelah konfirmasi.",
    donationTitle: "Pengaturan Penggalangan Dana & Kontribusi",
    donationPreset: "Preset Donasi",
    causeLabel: "Penerima Manfaat / Tujuan Proyek",
    causePh: "mis., Dana Perpustakaan Komunitas & Pembelian Peralatan",
    donationNote: "Notifikasi resi donasi dan kebijakan pembayaran sukarela aktif.",
    membershipTitle: "Pengaturan Tingkat & Manfaat Keanggotaan",
    membershipPreset: "Preset Keanggotaan",
    tierNameLabel: "Nama Tingkat Keanggotaan",
    tierNamePh: "mis., Pas Emas Tahunan",
    validityLabel: "Masa Berlaku",
    validityPh: "mis., 1 Tahun (Jan 2026 - Des 2026)",
    serviceTitle: "Pengaturan Pemesanan Layanan & Slot",
    servicePreset: "Preset Layanan",
    durationLabel: "Durasi Sesi",
    durationPh: "mis., 60 Menit per sesi",
    locationLabel: "Lokasi / Tempat",
    locationPh: "mis., Studio Utama & Pusat Janji Temu",
    propertyTitle: "Pengaturan Peluncuran Properti & Roadshow",
    propertyPreset: "Preset Properti",
    venueLabel2: "Tempat Roadshow / Galeri Penjualan",
    venuePh2: "mis., Pusat Konvensi Sentral & Galeri Penjualan",
    unitLabel: "Kategori Unit Unggulan",
    unitPh: "mis., Kondominium Mewah & Suite Eksekutif",
    vehicleTitle: "Pengaturan Peluncuran Kendaraan & Test Drive",
    vehiclePreset: "Preset Kendaraan",
    showroomLabel: "Lokasi Showroom / Test Drive",
    showroomPh: "mis., Showroom Utama & Lintasan Tes",
    modelLabel: "Model / Edisi Kendaraan",
    modelPh: "mis., Edisi Performa Olahraga 2026",
    sizeVariations: "Ukuran & Variasi",
    sizeVariationsHint: "Aktifkan ukuran yang Anda tawarkan. Gunakan Ganti Harga untuk menetapkan harga berbeda untuk ukuran lebih besar (mis., 3XL, 4XL, 5XL). Biarkan kosong untuk menggunakan harga dasar lengan.",
    sizeHeader: "Ukuran",
    enabledHeader: "Diaktifkan",
    priceOverrideHeader: "Ganti Harga (RM)",
    skuHeader: "SKU",
    priceLabel: "Harga:",
    setBasePrice: "Tetapkan harga dasar",
    sizesLabel: "Ukuran:",
    campaignDetails: "Detail Kampanye",
    campaignCover: "Sampul Kampanye",
    coverDesc: "Banner utama untuk pratinjau kampanye publik. Gambar pemasaran / branding — bukan gambar produk.",
    noCoverYet: "Belum ada sampul — banner bawaan sekolah atau banner Cheeco akan ditampilkan di halaman publik.",
    coverPoster: "Poster Sampul",
    productImage: "Gambar Produk",
    productImageHint: "(diperlukan sebelum kirim)",
    productImageDesc: "Unggah foto pakaian/produk sebenarnya. Gambar ini ditampilkan kepada orang tua di halaman kampanye dan di keranjang mereka.",
    productImageRequired: "Gambar produk diperlukan sebelum Anda dapat mengirim kampanye ini.",
    shortDescription: "Deskripsi Singkat",
    shortDescriptionPh: "Jelaskan tentang kampanye ini...",
    orderCutoff: "Batas Pesanan",
    orderCutoffPh: "Pilih tanggal & waktu batas",
    paymentDue: "Pembayaran Jatuh Tempo",
    paymentDuePh: "Pilih tanggal & waktu pembayaran",
    distributionDate: "Tanggal Distribusi / Pengambilan",
    distributionDatePh: "Pilih tanggal & waktu distribusi",
    visibility: "Visibilitas",
    buyerAccessMode: "Mode Akses Pembeli",
    buyerAccessDesc: "Pilih apakah kampanye ini dibatasi untuk Anggota Organisasi atau terbuka untuk publik.",
    membersOnly: "🔒 Khusus Anggota",
    membersOnlyDesc: "Hanya Anggota Organisasi yang disetujui yang dapat melihat dan membeli.",
    publicOpen: "🌐 Publik (Terbuka untuk Semua)",
    publicOpenDesc: "Siapa pun dengan tautan atau kode QR dapat membeli langsung tanpa bergabung.",
    paymentSettings: "Pengaturan Pembayaran",
    defaultPaymentMethod: "Metode Pembayaran Bawaan",
    defaultAllocationMethod: "Metode Alokasi Bawaan",
    distributionTitle: "Distribusi",
    distributionMethod: "Metode Distribusi",
    collectionPoint: "Titik Pengambilan / Tempat",
    collectionPointPh: "mis., {{default}}",
    sportsHouseConfig: "Konfigurasi Rumah Olahraga",
    sportsHouseDesc: "Kelompokkan siswa ke dalam rumah olahraga sehingga setiap variasi jersey menampilkan warna dan lambang rumah yang benar.",
    assignmentMethod: "Metode Penugasan",
    useCsv: "Gunakan CSV Siswa",
    parentSelect: "Orang Tua Pilih Saat Checkout",
    noHouse: "Tanpa Rumah Olahraga",
    recommended: "Disarankan",
    recommendedDesc: "Disarankan — cocok dengan catatan resmi",
    csvHelpText: "CSV Siswa membaca Rumah Olahraga siswa dari daftar anggota yang diimpor dan menetapkannya secara otomatis. Orang tua tidak dapat mengubahnya.",
    sportsHouses: "Rumah Olahraga",
    addHouse: "+ Tambah Rumah",
    noHousesYet: "Belum ada rumah yang ditambahkan. Tambahkan rumah (mis. Merah, Biru, Hijau, Kuning).",
    housePh: "mis., Rumah Merah",
    houseColour: "Warna rumah",
    removeHouse: "Hapus rumah",
    parentsChoose: "Orang tua akan memilih salah satu rumah ini saat checkout.",
    quantitySettings: "Pengaturan Kuantitas",
    quantityTarget: "Target Kuantitas",
    minOrderQty: "Min Pesanan",
    maxOrderQty: "Maks Pesanan",
    saveDraft: "Simpan sebagai Draf",
    publishing: "Menerbitkan...",
    publish: "Terbitkan",
    saveContinue: "Simpan & Lanjutkan",
    visOrgOnly: "Khusus Organisasi",
    visPublic: "Publik",
    visPrivate: "Pribadi (Hanya Undangan)",
    pmOnline: "Pembayaran Online",
    pmManual: "Pembayaran Manual",
    pmFunding: "Pendanaan / Ditanggung",
    pmComplimentary: "Gratis (FOC)",
    allocOpen: "Akses Terbuka",
    allocCodes: "Kode Kampanye",
    allocManual: "Persetujuan Manual",
    distCollection: "Pengambilan",
    distDelivery: "Pengiriman",
    distBoth: "Keduanya",
    errLoadCampaign: "Gagal memuat kampanye",
    errUploadPoster: "Gagal mengunggah poster",
    errNameRequired: "Nama kampanye diperlukan",
    errBasePriceRequired: "Harga dasar diperlukan sebelum menerbitkan",
    errSizeRequired: "Setidaknya satu ukuran harus diaktifkan sebelum menerbitkan",
    errOpeningRequired: "Tanggal pembukaan diperlukan sebelum menerbitkan",
    errClosingRequired: "Tanggal penutupan diperlukan sebelum menerbitkan",
    errClosingAfterOpening: "Tanggal penutupan harus setelah tanggal pembukaan",
    errHouseRequired: "Tambahkan setidaknya satu rumah olahraga sebelum menerbitkan",
    errSave: "Gagal menyimpan kampanye",
    errPublish: "Gagal menerbitkan kampanye",
    errChangeReason: "Silakan berikan alasan untuk permintaan perubahan (setidaknya 3 karakter).",
    errSubmitChange: "Gagal mengirim permintaan perubahan",
    confirmCancelChange: "Batalkan permintaan perubahan ini? Kampanye akan tetap tidak berubah.",
    errCancelChange: "Gagal membatalkan permintaan perubahan",
    useCampaignDefault: "Gunakan Bawaan Kampanye",
    autoAlloc: "Otomatis",
    codeRequired: "Kode Diperlukan",
    editItem: "Edit Produk",
    addItem: "Tambah Produk",
    whatIsAvailable: "Apa yang tersedia untuk dipesan?",
    itemInfo: "Informasi Produk",
    itemName: "Nama Produk",
    itemNamePh: "mis., Kemeja Olahraga",
    itemImage: "Gambar Produk",
    houseJerseyImages: "Gambar Jersey Rumah Olahraga",
    houseJerseyDesc: "Unggah gambar jersey terpisah untuk setiap rumah agar orang tua melihat warna rumah yang benar saat checkout.",
    houseJerseyImage: "Gambar Jersey Rumah",
    descLabel: "Deskripsi",
    descPh: "Jelaskan produk ini...",
    sellingPrice: "Harga Jual",
    unlimited: "Tanpa Batas",
    limited: "Terbatas",
    availableQtyPh: "Kuantitas tersedia",
    optionsOptional: "Opsi (Opsional)",
    optionsDesc: "Tambahkan opsi sederhana seperti Ukuran, Warna, Gender. Sistem akan membuat semua kombinasi secara otomatis.",
    optionNamePh: "Nama opsi (mis., Ukuran)",
    optionValuesPh: "Nilai (satu per baris atau dipisahkan koma)",
    addOption: "Tambah Opsi",
    paymentOverride: "Ganti Pembayaran (Opsional)",
    paymentOverrideDesc: "Gantikan bawaan kampanye untuk produk ini, atau biarkan kosong untuk menggunakan pengaturan kampanye.",
    itemPaymentMethod: "Metode Pembayaran",
    allocationMethodLabel: "Metode Alokasi",
    updateItem: "Perbarui Produk",
    saveItem: "Simpan Produk",
    errLoadItem: "Gagal memuat produk",
    errUploadImage: "Gagal mengunggah gambar",
    errUploadHouseImage: "Gagal mengunggah gambar rumah",
    errItemNameRequired: "Nama produk diperlukan",
    errSellingPrice: "Harga jual diperlukan",
    errQtyRequired: "Kuantitas tersedia diperlukan jika tidak tanpa batas",
    errSaveItem: "Gagal menyimpan produk",
    ticketTiers: "Tingkatan Tiket",
    addTicketTier: "+ Tambah Tingkatan Tiket",
    tierName: "Nama Tingkatan",
    tierPrice: "Harga (RM)",
    tierCapacity: "Kapasitas / Kuantitas",
    tierSku: "SKU",
    removeTier: "Hapus",
    tierNameRequired: "Nama tingkatan diperlukan.",
    tierDuplicateName: "Nama tingkatan harus unik dalam kampanye.",
    tierPriceRequired: "Harga tingkatan diperlukan dan harus lebih dari 0.",
    tierCapacityRequired: "Kapasitas tingkatan diperlukan dan harus lebih dari 0.",
    tierSkuDuplicate: "SKU tingkatan harus unik dalam kampanye.",
    atLeastOneTier: "Setidaknya satu tingkatan tiket diperlukan.",
    tiersHint: "Setiap tingkatan adalah tiket yang dapat dibeli secara terpisah dengan harga dan kapasitasnya sendiri.",
    tiersLabel: "Tingkatan:",
    capacityLeft: "{{n}} tersisa",
    selectTierPh: "Pilih tingkatan untuk melihat harganya.",
    errInvalidFormat: "Format tidak valid: {{type}}. Hanya JPG, PNG, dan WebP yang diterima.",
    errFileTooLarge: "File terlalu besar: {{size}}. Maksimum {{max}} MB.",
    errImageRatio: "Rasio gambar adalah {{ratio}} tetapi yang disarankan adalah {{recommended}} ({{label}}). Gambar mungkin terpotong atau ditampilkan salah.",
    recommended2: "Disarankan: {{ratio}}",
    uploading: "Mengunggah...",
    clickToUpload: "Klik untuk mengunggah atau seret dan lepas",
    uploadFormats: "JPG, PNG, WebP hingga {{max}} MB",
    previewAlt: "Pratinjau",
    removeImage: "Hapus gambar",
    webpNotice: "Gambar akan dikonversi ke WebP secara otomatis dan dioptimalkan untuk pengiriman web.",
    selectDate: "Pilih tanggal",
    ratioCover: "Sampul Kampanye",
    ratioProduct: "Produk / Logo",
    ratioGallery: "Galeri / Gaya Hidup",
    prevYear: "Tahun Sebelumnya",
    prevMonth: "Bulan Sebelumnya",
    nextMonth: "Bulan Berikutnya",
    nextYear: "Tahun Berikutnya",
    timeLabel: "Waktu",
    today: "Hari Ini",
    done: "Selesai",
  },
};

export default id;
